/* Paket oluştur — sections/xenon-paket-olustur.liquid.
 *
 * One box per required product (head), one row of cards per pool (body), a
 * fixed footer with the total, a summary once every box is filled. State is
 * the boxes' picks; it survives a reload (localStorage, 7 days) and a
 * ?set=key.<variant>~… link (the set builder's share format, read once and
 * then dropped from the URL). The cart lines carry the set builder's
 * properties, so a package IS a builder set to the cart, the drawer and the
 * reports.
 *
 * READY SETS (Kedi, data-xpk-hazir): the set builder's sade-mode discount.
 * Boxes that hold a ready set — with what the "Bu ürünü setine ekle" line
 * added beside them (a fountain's filter) — go to the cart as that set at
 * its own price; a set one such product short is offered in the summary.
 *
 * EK ÜRÜN ("+", data-xpk-add): the shopper adds a box of a chosen type
 * beyond the required ones — a head box (cloned from data-xpk-ek-slot-tpl)
 * and that type's row, shown under the last row. Kept with the picks; never
 * a box the gift waits for.
 *
 * ADET (data-adet-max, every set family): the picked card's "Seçildi" is a
 * "− 1 adet +" stepper, so is its summary row (and the offer's); the cart
 * line goes with that quantity, up to the page's maximum or the variant's
 * stock. A set discount stays on one unit of its line — the cart's
 * functions target one unit — and the gift is always one. */
(function () {
  if (customElements.get('xenon-paket')) return;

  var STORE_TTL = 7 * 24 * 60 * 60 * 1000;
  var TIP_KEY = 'xenon-paket:ipucu';
  // Packages of one family in one cart — the set builder's MAX_SETS.
  var MAX_SETS = 2;
  // Products the set line may add beside the boxes — the set builder's
  // MAX_EXTRAS.
  var MAX_EXTRAS = 3;
  // The cart step of the summary's offer ("Kedi Seti Kademeli İndirim").
  var TEKLIF_KEY = 'teklif';

  function money(cents) {
    var fmt = window.FoxTheme && FoxTheme.settings && FoxTheme.settings.moneyFormat;
    if (window.FoxTheme && FoxTheme.Currency && FoxTheme.Currency.formatMoney) {
      return FoxTheme.Currency.formatMoney(cents, fmt);
    }
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }

  /* "Akıllı Kettle | Mobil Kontrol, …" → "Akıllı Kettle" for the notes. */
  function shortName(title) {
    var head = String(title || '').split('|')[0].trim();
    return head || String(title || '');
  }

  /* Two models with one short name ("Hava Temizleyici") told apart by
     their model code: "Hava Temizleyici (X7421)". */
  function namePair(a, b) {
    var na = shortName(a);
    var nb = shortName(b);
    if (na !== nb) return [na, nb];
    var code = function (t) {
      var m = String(t || '').match(/\b[A-Z]\d{4}\b/g);
      return m ? ' (' + m[m.length - 1] + ')' : '';
    };
    return [na + code(a), nb + code(b)];
  }

  /* A set part as the money lines name it: the short name without its
     "(X8652 ve X8653 Uyumlu)", then the model code (the set builder's
     shortName()). */
  function partName(c) {
    var base = String((c && (c.kisaAd || c.title)) || '');
    var clean = base
      .replace(/\s*\([^)]*\)/g, '')
      .replace(/\s*X\d{4}\s*$/, '')
      .trim();
    return (clean || base) + (c && c.kod ? ' ' + c.kod : '');
  }

  /* A selection as the cart line and the set sentence name it: a set
     part's short name, else the title's head and its model code ("Kedi Su
     Pınarı X8650"). */
  function itemName(x) {
    if (x.short) return x.short;
    var head = shortName(x.title);
    var codes = String(x.title || '').match(/\b[A-Z]\d{4}\b/g);
    var code = codes ? codes[codes.length - 1] : '';
    return code && head.indexOf(code) === -1 ? head + ' ' + code : head;
  }

  /* The model codes in a title: "… (Beyaz - X8650)" → ["X8650"],
     "… X8623-X8624" → ["X8623", "X8624"]. */
  function codesOf(title) {
    return String(title || '').toUpperCase().match(/\bX\d{4}\b/g) || [];
  }

  /* The units a pick stands for: the stepper's (data-adet-max), else one. */
  function units(x) {
    return (x && x.qty) || 1;
  }

  /* A set discount as the page is given it: "10" is 10 % off one unit,
     "250TL" (a Kampanya Seti set's) 250 TL off one unit — what the cart's
     discount takes off. Null for none. */
  function parseDeal(x) {
    var raw = String(x == null ? '' : x).replace(/\s+/g, '').toUpperCase();
    var tl = /TL$|₺/.test(raw);
    var n = parseFloat(raw.replace(/TL$|₺|%/g, '').replace(',', '.'));
    if (!(n > 0)) return null;
    if (tl) return { tl: n };
    return n < 100 ? { pct: n } : null;
  }

  /* What a deal takes off one unit of a price (cents), rounded to the kuruş
     as the cart's discount is; an amount never past the price. */
  function dealCut(price, deal) {
    if (!deal) return 0;
    if (deal.tl) return Math.min(price, Math.round(deal.tl * 100));
    return Math.round((price * deal.pct) / 100);
  }

  /* A row's discounts per product (data-urun-indirim: product id → "15",
     "250TL" or "0"), null for none. */
  function urunMap(raw) {
    if (!raw) return null;
    try {
      var map = JSON.parse(raw);
      return map && typeof map === 'object' && Object.keys(map).length ? map : null;
    } catch (e) {
      return null;
    }
  }

  /* "%10" or "250,00 TL"; a bare number is a percent (the offer's). */
  function dealLabel(deal) {
    if (typeof deal === 'number') return '%' + deal;
    return deal.tl ? money(Math.round(deal.tl * 100)) : '%' + deal.pct;
  }

  /* A summary row's discount chip: the set discount is on one unit of the
     line (the cart's), so a line of several says so. */
  function dealText(deal, n) {
    return dealLabel(deal) + ' İndirim' + (n > 1 ? ' · 1 adede' : '');
  }

  /* A stepper button that stays pressable at its limit (the press says
     why) but reads as off. */
  function setOff(el, off) {
    if (!el) return;
    el.classList.toggle('is-off', off);
    if (off) el.setAttribute('aria-disabled', 'true');
    else el.removeAttribute('aria-disabled');
  }

  /* "A", "A ve B", "A, B ve C". */
  function listTr(names) {
    if (names.length < 2) return names.join('');
    return names.slice(0, -1).join(', ') + ' ve ' + names[names.length - 1];
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function readStore(key) {
    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return null;
      var rec = JSON.parse(raw);
      if (!rec || !rec.t || Date.now() - rec.t > STORE_TTL) return null;
      return rec;
    } catch (e) {
      return null;
    }
  }

  function writeStore(key, value) {
    try {
      if (value) window.localStorage.setItem(key, JSON.stringify(value));
      else window.localStorage.removeItem(key);
    } catch (e) {
      /* private mode: the package simply does not come back */
    }
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  class XenonPaket extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        // Back in the document (the theme editor moved the section): the
        // page-level hooks come back with it.
        this.attachGlobal();
        return;
      }
      this.ready = true;
      this.productId = this.dataset.productId;
      this.setLabel = this.dataset.setLabel || '';
      this.family = this.dataset.family || '';
      this.storeKey = 'xenon-paket:' + this.productId;
      this.setPrefix = 'xsb-' + this.productId + '-';

      this.headEl = this.querySelector('[data-xpk-head]');
      this.stepNumEl = this.querySelector('[data-xpk-step-num]');
      this.stepTextEl = this.querySelector('[data-xpk-step-text]');
      this.progressEl = this.querySelector('[data-xpk-progress]');
      this.introImg = this.querySelector('[data-xpk-intro-img]');
      this.catsEl = this.querySelector('[data-xpk-cats]');
      this.summaryEl = this.querySelector('[data-xpk-summary]');
      this.summaryTitle = this.querySelector('[data-xpk-summary-title]');
      this.summaryImgs = this.querySelector('[data-xpk-summary-imgs]');
      this.summaryList = this.querySelector('[data-xpk-summary-list]');
      this.footEl = this.querySelector('[data-xpk-foot]');
      this.totalEl = this.querySelector('[data-xpk-total]');
      this.countEl = this.querySelector('[data-xpk-count]');
      this.noteEl = this.querySelector('[data-xpk-note]');
      this.ctaEl = this.querySelector('[data-xpk-cta]');
      this.ctaLabelEl = this.querySelector('[data-xpk-cta-label]');
      this.ctaText = this.ctaLabelEl ? this.ctaLabelEl.textContent.trim() : 'Sepete Ekle';
      this.tipEl = this.querySelector('[data-xpk-tip]');
      this.matchEl = this.querySelector('[data-xpk-match]');
      this.offerEl = this.querySelector('[data-xpk-offer]');
      this.gainEl = this.querySelector('[data-xpk-gain]');
      this.slotsEl = this.querySelector('[data-xpk-slots]');
      this.addEl = this.querySelector('[data-xpk-add]');
      this.addTypesEl = this.querySelector('[data-xpk-add-types]');
      this.addMaxEl = this.querySelector('[data-xpk-add-max]');
      this.addTile = this.querySelector('[data-xpk-add-tile]');
      this.ekTpl = this.querySelector('[data-xpk-ek-slot-tpl]');
      this.ekMax = this.addEl ? parseInt(this.addEl.dataset.max, 10) || 3 : 0;
      this.ekSeq = 0;
      // "paket" (Çeyiz) or "set" (Kedi), see word().
      this.noun = this.dataset.noun || 'paket';
      // "0,5,15": the required boxes' set discount in box order (Kedi). The
      // cart's "Kedi Seti Kademeli İndirim" takes it off; the page shows it.
      // A Kampanya Seti set may give amounts too ("0,10,250TL").
      this.kademe = String(this.dataset.kademe || '')
        .split(',')
        .map(parseDeal);
      this.kademeOn = this.kademe.some(Boolean);

      var self = this;
      this.slots = Array.prototype.map.call(this.querySelectorAll('[data-xpk-slot]'), function (el, i) {
        return {
          el: el,
          key: el.dataset.key,
          pool: el.dataset.pool,
          label: el.dataset.label,
          gift: el.dataset.gift === 'true',
          ek: el.dataset.ek === 'true',
          index: i,
          sel: null,
          at: 0,
        };
      });
      this.cats = Array.prototype.map.call(this.querySelectorAll('[data-xpk-cat]'), function (el) {
        var hint = el.querySelector('[data-xpk-gift-hint]');
        return {
          el: el,
          pool: el.dataset.pool,
          gift: el.dataset.gift === 'true',
          ek: el.dataset.ek === 'true',
          name: el.dataset.title || '',
          ekCount: el.querySelector('[data-xpk-ek-count]'),
          title: el.querySelector('.xpk__cat-title'),
          hint: hint,
          hintLocked: hint ? hint.textContent.trim() : '',
          urun: urunMap(el.dataset.urunIndirim),
          models: 0,
        };
      });
      // A row asks for no more boxes than it has models: a row with every
      // model sold out drops out, and two boxes sharing a row with one model
      // left keep one (two boxes never hold one model).
      this.cats.forEach(function (cat) {
        var groups = {};
        Array.prototype.forEach.call(cat.el.querySelectorAll('[data-xpk-card]'), function (c) {
          groups[c.dataset.group] = true;
        });
        var models = Object.keys(groups).length;
        cat.models = models;
        if (!models) cat.el.hidden = true;
        self.slotsOf(cat.pool).forEach(function (s, i) {
          if (i < models) return;
          s.off = true;
          var li = s.el.closest('li');
          if (li) li.hidden = true;
        });
      });

      // A "+" type with its own set discount (ek_tur "indirim", Köpek:
      // Bakım) counts as one: it comes off once the boxes are filled.
      // So does a product with its own (a Kampanya Seti box's, even when the
      // box has none).
      if (
        this.cats.some(function (c) {
          return (
            !!self.ekDeal(c.pool) ||
            (!!c.urun &&
              Object.keys(c.urun).some(function (id) {
                return !!parseDeal(c.urun[id]);
              }))
          );
        })
      ) {
        this.kademeOn = true;
      }

      // "Sette %5 indirim" on a discounted box's row.
      if (this.kademeOn) {
        var dealChip = function (cat, deal) {
          if (!cat || !cat.title || cat.title.querySelector('.xpk__cat-deal')) return;
          var text = cat.urun ? self.rowDealText(cat) : deal ? dealLabel(deal) + ' İndirim' : '';
          if (!text) return;
          var chip = document.createElement('span');
          chip.className = 'xpk__cat-deal';
          chip.textContent = text;
          cat.title.appendChild(chip);
        };
        this.baseSlots().forEach(function (s) {
          dealChip(
            self.cats.find(function (c) {
              return c.pool === s.pool;
            }),
            self.baseDeal(s)
          );
        });
        this.cats.forEach(function (c) {
          if (c.ek) dealChip(c, self.ekDeal(c.pool));
        });
        // Its cards: the struck price and the set price.
        Array.prototype.forEach.call(this.querySelectorAll('[data-xpk-card]'), function (card) {
          self.cardPrice(card);
        });
      }

      // The summary's offer (Kedi): the "+" type whose step is
      // data-teklif-adim gives the consumables; one that fits the set's
      // products goes in at data-teklif-pct off ("Kedi Seti Kademeli
      // İndirim" takes it off in the cart, step "teklif").
      this.teklifPct = parseFloat(this.dataset.teklifPct) || 0;
      this.teklifCat = null;
      if (this.teklifPct > 0 && this.teklifPct < 100) {
        var teklifAdim = this.dataset.teklifAdim;
        this.teklifCat =
          this.cats.find(function (c) {
            return c.ek && c.el.dataset.adim === teklifAdim;
          }) || null;
      }
      this.teklif = null;
      this.teklifEl = this.querySelector('[data-xpk-teklif]');
      this.teklifSig = '';

      this.targetKey = null;
      this.viewPool = this.cats.length ? this.cats[0].pool : null;
      this.showSummary = false;
      this.cartSigs = {};
      this.clock = 0;
      // What the set line added beside the boxes (picks of set parts).
      this.extras = [];
      // The product the set line last added — "the free one" of the set.
      this.freeHint = '';
      this.loadReady();
      // Units per box. A set discount stays on one unit of its line, as the
      // cart's "Kedi Seti Kademeli İndirim" gives it; the others are at their
      // own price. Never beside ready sets: those match one unit per box.
      var adetMax = parseInt(this.dataset.adetMax, 10) || 0;
      this.qtyMax = adetMax > 1 && !this.readyOn ? adetMax : 0;

      this.restore();
      this.bind();
      this.render();
      this.syncCardColours();
      this.observeRows();
      this.observeTracks();
      this.attachGlobal();
      this.showTip();
      this.readCart();
    }

    disconnectedCallback() {
      this.detachGlobal();
    }

    /* Page-level hooks: footer padding, window listeners, the cart feed. */
    attachGlobal() {
      if (this.globalOn) return;
      this.globalOn = true;
      var self = this;
      document.body.classList.add('xpk-has-foot');
      this.measureFoot();
      this.onWinScroll = function () {
        if (self.tipEl && !self.tipEl.hidden && window.scrollY > (self.tipScrollY || 0) + 60) self.hideTip(true);
        if (!self.scrollLock) return;
        clearTimeout(self.scrollTimer);
        self.scrollTimer = setTimeout(function () {
          self.releaseLock();
        }, 140);
      };
      this.onKey = function (e) {
        if (e.key !== 'Escape') return;
        self.hideTip(true);
        if (self.addTypesEl && !self.addTypesEl.hidden) self.setAddOpen(false);
      };
      window.addEventListener('scroll', this.onWinScroll, { passive: true });
      document.addEventListener('keydown', this.onKey);
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
        try {
          this.unsubCart = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
            if (event && event.cart && Array.isArray(event.cart.items)) {
              self.applyCart(event.cart);
              self.render();
            }
          });
        } catch (e) {
          this.unsubCart = null;
        }
      }
    }

    detachGlobal() {
      if (!this.globalOn) return;
      this.globalOn = false;
      document.body.classList.remove('xpk-has-foot');
      window.removeEventListener('scroll', this.onWinScroll);
      document.removeEventListener('keydown', this.onKey);
      if (this.footObserver) this.footObserver.disconnect();
      if (typeof this.unsubCart === 'function') this.unsubCart();
      this.unsubCart = null;
    }

    /* ------------------------------------------------------------ model */

    activeSlots() {
      return this.slots.filter(function (s) {
        return !s.off;
      });
    }

    slotsOf(pool) {
      return this.slots.filter(function (s) {
        return s.pool === pool;
      });
    }

    activeIn(pool) {
      return this.slotsOf(pool).filter(function (s) {
        return !s.off;
      });
    }

    slotByKey(key) {
      return this.slots.find(function (s) {
        return s.key === key;
      });
    }

    /* The gift (a box of a "hediye" step): free in checkout through the
       "Çeyiz Paketi Hediyesi" discount, chosen only once every paid box is
       filled — the retailer's step order, and the discount's own rule. */
    paidSlots() {
      return this.activeSlots().filter(function (s) {
        return !s.gift;
      });
    }

    giftSlot() {
      return (
        this.activeSlots().find(function (s) {
          return s.gift;
        }) || null
      );
    }

    giftLocked() {
      return (
        !!this.giftSlot() &&
        this.baseSlots().some(function (s) {
          return !s.sel;
        })
      );
    }

    /* The required boxes: not the gift, not one the shopper added. */
    baseSlots() {
      return this.activeSlots().filter(function (s) {
        return !s.gift && !s.ek;
      });
    }

    ekSlots() {
      return this.activeSlots().filter(function (s) {
        return s.ek;
      });
    }

    complete() {
      var act = this.activeSlots();
      return (
        act.length > 0 &&
        act.every(function (s) {
          return !!s.sel;
        })
      );
    }

    filledCount() {
      return this.activeSlots().filter(function (s) {
        return !!s.sel;
      }).length;
    }

    /* What the shopper pays: the paid boxes — the gift is free. */
    total() {
      return this.paidSlots().reduce(function (sum, s) {
        return sum + (s.sel ? s.sel.price * units(s.sel) : 0);
      }, 0);
    }

    firstEmpty() {
      return (
        this.activeSlots().find(function (s) {
          return !s.sel;
        }) || null
      );
    }

    /* The variant ids of the package's cart lines (a ready set as its own
       variant), once per unit, as the cart is compared with. */
    sig() {
      var plan = this.planLines();
      var ids = [];
      plan.lines.forEach(function (x) {
        for (var q = 0; q < units(x); q += 1) ids.push(String(x.variantId));
      });
      if (plan.set) ids.push(String(plan.set.variantId));
      return ids.sort().join(',');
    }

    /* The box the step line speaks for: the one the shopper aimed at (a
       tapped box), else the first empty box of the row on screen, else the
       first empty box. */
    currentSlot() {
      var locked = this.giftLocked();
      if (this.targetKey) {
        var t = this.slotByKey(this.targetKey);
        if (t && !t.off && !(t.gift && locked)) return t;
      }
      var inView = this.viewPool
        ? this.activeIn(this.viewPool).find(function (s) {
            return !s.sel && !(s.gift && locked);
          })
        : null;
      return inView || this.firstEmpty() || (this.viewPool ? this.activeIn(this.viewPool)[0] || null : null);
    }

    /* A card's colour on show, as a pick. */
    cardPick(card) {
      var d = card.dataset;
      return {
        group: d.group,
        handle: d.handle,
        productId: d.productId,
        variantId: d.variantId,
        price: parseInt(d.price, 10) || 0,
        title: d.title || '',
        img: d.img || '',
        stok: parseInt(d.stok, 10) || 0,
      };
    }

    slotOfGroup(pool, group, except) {
      return this.slotsOf(pool).find(function (s) {
        return s !== except && s.sel && s.sel.group === group;
      });
    }

    /* "paketine" / "setine": both nouns take the same suffixes. */
    word(suffix, cap) {
      var w = this.noun + (suffix || '');
      return cap ? w.charAt(0).toLocaleUpperCase('tr') + w.slice(1) : w;
    }

    /* ------------------------------------------------------- ready sets */

    /* The set builder's ready-set map (snippets/xenon-set-ready-map.liquid):
       `setler` — sets of this family with ≥2 verified components (`ids`, a
       multiset of product ids); `parcalar` — the products of those sets no
       box offers (filters, a camera), as manifest items. */
    loadReady() {
      var el = this.querySelector('[data-xpk-hazir]');
      var data = null;
      try {
        data = el ? JSON.parse(el.textContent) : null;
      } catch (e) {
        data = null;
      }
      this.readySets = ((data && data.setler) || [])
        .filter(function (s) {
          return s && s.variantId && s.price > 0 && Array.isArray(s.components) && s.components.length >= 2;
        })
        .map(function (s) {
          s.ids = s.components.map(String);
          s.key = s.ids.slice().sort().join(',');
          return s;
        });
      this.readyOn = this.readySets.length > 0;
      var parts = {};
      ((data && data.parcalar) || []).forEach(function (c) {
        if (c && c.productId) parts[String(c.productId)] = c;
      });
      this.parts = parts;
      // A ready set records PRODUCTS and sells its own one variant: a product
      // that comes in several can never stand in one (the shopper's variant
      // would be swapped for the set's).
      var multi = {};
      Array.prototype.forEach.call(this.querySelectorAll('[data-xpk-card][data-multi="true"]'), function (card) {
        multi[String(card.dataset.productId)] = true;
      });
      Object.keys(parts).forEach(function (id) {
        if ((parts[id].variants || []).length > 1) multi[id] = true;
      });
      this.multiIds = multi;
      this.readyVersion = 0;
      this.readyCache = null;
    }

    multiVariant(productId) {
      return !!this.multiIds[String(productId)];
    }

    /* A set part as a pick (it has one variant: see readyState()). */
    partPick(c) {
      var v = (c && c.variants && c.variants[0]) || null;
      if (!v) return null;
      return {
        group: 'parca:' + c.handle,
        handle: c.handle,
        productId: String(c.productId),
        variantId: String(v.id),
        price: v.price || c.price || 0,
        title: c.title || '',
        short: partName(c),
        img: c.img || '',
        part: true,
      };
    }

    partByVariant(vid) {
      var parts = this.parts || {};
      var ids = Object.keys(parts);
      for (var i = 0; i < ids.length; i += 1) {
        var c = parts[ids[i]];
        var hit = (c.variants || []).some(function (v) {
          return String(v.id) === String(vid);
        });
        if (hit) return c;
      }
      return null;
    }

    /* Every selection in cart order — the boxes, then what the set line
       added — each with the step key its cart line carries. */
    allSels() {
      var out = [];
      this.activeSlots().forEach(function (s) {
        if (s.sel) out.push(Object.assign({}, s.sel, { adim: s.key }));
      });
      if (this.teklif) out.push(Object.assign({}, this.teklif, { adim: TEKLIF_KEY }));
      this.extras.forEach(function (x) {
        out.push(Object.assign({}, x, { adim: 'ekstra' }));
      });
      return out;
    }

    extrasSum() {
      return this.extras.reduce(function (n, x) {
        return n + (x.price || 0);
      }, 0);
    }

    /* The set builder's readyMatchFor() (sade mode), for any list of
       selections. match: among the in-stock sets whose every product is in
       the selections (one unit each) and that cost no more than those
       products do — the set that is exactly the selections, else the
       biggest saving, then the bigger set, then the cheaper one. What is
       left over (`rest`) goes to the cart beside the set at its own price.
       soldOut: the selections are EXACTLY a set, but none is in stock. */
    readyMatchFor(sels) {
      var out = { match: null, soldOut: null, rest: [], restSum: 0, compSum: 0, taken: [] };
      if (!this.readyOn) return out;
      sels = sels || [];
      if (sels.length < 2) return out;
      var self = this;
      var multi = function (id) {
        return self.multiVariant(id);
      };
      var ids = sels.map(function (x) {
        return String(x.productId);
      });
      var uniq = ids.filter(function (id, i) {
        return ids.indexOf(id) === i;
      });
      var exactKey = uniq.length === ids.length && !ids.some(multi) ? uniq.slice().sort().join(',') : '';
      var best = null;
      var soldOut = null;
      var exactInStock = false;
      this.readySets.forEach(function (set) {
        var taken = [];
        for (var k = 0; k < set.ids.length; k += 1) {
          var at = -1;
          for (var i = 0; i < ids.length; i += 1) {
            if (ids[i] === set.ids[k] && taken.indexOf(i) === -1) {
              at = i;
              break;
            }
          }
          if (at === -1) return;
          taken.push(at);
        }
        if (set.ids.some(multi)) return;
        var exact = !!exactKey && set.key === exactKey;
        if (!set.available) {
          if (exact && !soldOut) soldOut = set;
          return;
        }
        if (exact) exactInStock = true;
        var compSum = taken.reduce(function (n, i) {
          return n + (sels[i].price || 0);
        }, 0);
        // A set dearer than its own parts is not worth selling.
        if (set.price > compSum) return;
        var gain = compSum - set.price;
        var cover = set.ids.length;
        var better =
          !best ||
          (exact && !best.exact) ||
          (exact === best.exact &&
            (gain > best.gain ||
              (gain === best.gain && cover > best.cover) ||
              (gain === best.gain && cover === best.cover && set.price < best.set.price)));
        if (better) best = { set: set, taken: taken, compSum: compSum, gain: gain, cover: cover, exact: exact };
      });
      if (best) {
        out.match = best.set;
        out.taken = best.taken;
        out.compSum = best.compSum;
        sels.forEach(function (x, i) {
          if (best.taken.indexOf(i) !== -1) return;
          out.rest.push(x);
          out.restSum += x.price || 0;
        });
      } else if (soldOut && !exactInStock) {
        out.soldOut = soldOut;
      }
      return out;
    }

    /* What the selections are against the ready sets, memoised on them:
       the match (readyMatchFor), and — once every box is filled — the
       nearest set: one set part short of an in-stock set that costs less
       than the selections plus that part, measured as what the total would
       really move by. The best saving wins; there is never more than one. */
    readyState() {
      var sels = this.allSels();
      var sig =
        sels
          .map(function (x) {
            return x.variantId;
          })
          .join(',') +
        '#' +
        this.readyVersion;
      if (this.readyCache && this.readyCache.sig === sig) return this.readyCache;
      var out = { sig: sig, match: null, soldOut: null, nearest: null, rest: [], restSum: 0, compSum: 0, taken: [] };
      this.readyCache = out;
      if (!this.readyOn || !sels.length) return out;
      var self = this;
      var r = this.readyMatchFor(sels);
      out.match = r.match;
      out.soldOut = r.soldOut;
      out.rest = r.rest;
      out.restSum = r.restSum;
      out.compSum = r.compSum;
      out.taken = r.taken;
      if (!this.complete() || this.extras.length >= MAX_EXTRAS) return out;

      var current = out.match
        ? out.match.price + out.restSum
        : sels.reduce(function (n, x) {
            return n + (x.price || 0);
          }, 0);
      var ids = sels.map(function (x) {
        return String(x.productId);
      });
      var best = null;
      this.readySets.forEach(function (set) {
        if (!set.available) return;
        if (out.match && set.handle === out.match.handle) return;
        if (set.ids.some(self.multiVariant, self)) return;
        // As a multiset: one product short.
        var pool = ids.slice();
        var missing = [];
        set.ids.forEach(function (id) {
          var at = pool.indexOf(id);
          if (at === -1) missing.push(id);
          else pool.splice(at, 1);
        });
        if (missing.length !== 1) return;
        // Only a set part: a box's own product is the box's to choose.
        var c = self.parts[missing[0]];
        if (!c || !c.available || ids.indexOf(missing[0]) !== -1) return;
        var vs = c.variants || [];
        if (vs.length !== 1 || !vs[0].available) return;
        var pick = self.partPick(c);
        if (!pick) return;
        var after = self.readyMatchFor(sels.concat([Object.assign({}, pick, { adim: 'ekstra' })]));
        if (!after.match || after.match.handle !== set.handle) return;
        var delta = after.match.price + after.restSum - current;
        var own = pick.price || 0;
        if (!(delta < own)) return;
        var gain = own - delta;
        if (!best || gain > best.gain || (gain === best.gain && set.price < best.set.price)) {
          best = { set: set, pick: pick, gain: gain, delta: delta, own: own, total: current };
        }
      });
      out.nearest = best;
      return out;
    }

    /* What the footer shows and the cart charges. */
    payTotal() {
      var st = this.readyState();
      if (st.match) return st.match.price + st.restSum;
      return this.total() + this.extrasSum() - this.kademeSum() + this.teklifSum();
    }

    /* ------------------------------------------------------------ offer */

    /* The offer's consumables that fit the set: a consumable whose
       custom.uyumlu_modeller holds a box's product, or whose title names a
       box product's model code ("X8656 Uyumlu"). Each with the box product
       it fits; box order first. The ones taken stay on the list in their
       place (`held`: the offer, or an added box of its type) — the list
       never thins out under the shopper; of the rest at most three in all,
       none in the set otherwise. */
    teklifOptions() {
      if (!this.teklifCat || !this.kademeLive()) return [];
      var self = this;
      var held = this.teklifHeld();
      var inSet = {};
      this.allSels().forEach(function (x) {
        inSet[String(x.productId)] = true;
      });
      var fits = [];
      var cards = Array.prototype.slice.call(this.teklifCat.el.querySelectorAll('[data-xpk-card]'));
      this.baseSlots().forEach(function (s) {
        cards.forEach(function (card) {
          var id = card.dataset.productId;
          if (inSet[id] && !held[id]) return;
          if (fits.some(function (o) { return o.card === card; })) return;
          if (self.teklifFits(card, s)) fits.push({ card: card, fit: s, held: held[id] || null });
        });
      });
      var room = 3 - fits.filter(function (o) { return o.held; }).length;
      return fits.filter(function (o) {
        if (o.held) return true;
        room -= 1;
        return room >= 0;
      });
    }

    /* The consumables of the offer's type in the set, by product id: the
       offer itself ({ teklif }), or an added box of that type ({ key }). */
    teklifHeld() {
      var out = {};
      if (!this.teklifCat) return out;
      var pool = this.teklifCat.pool;
      this.ekSlots().forEach(function (s) {
        if (s.pool === pool && s.sel) out[String(s.sel.productId)] = { key: s.key };
      });
      if (this.teklif) out[String(this.teklif.productId)] = { teklif: true };
      return out;
    }

    teklifFits(card, slot) {
      if (!slot || !slot.sel) return false;
      var ids = String(card.dataset.uyumlu || '').split(',');
      if (ids.indexOf(String(slot.sel.productId)) !== -1) return true;
      var mine = codesOf(card.dataset.title);
      return codesOf(slot.sel.title).some(function (c) {
        return mine.indexOf(c) !== -1;
      });
    }

    teklifCard(productId) {
      if (!this.teklifCat) return null;
      return this.teklifCat.el.querySelector('[data-xpk-card][data-product-id="' + productId + '"]');
    }

    /* The offer in the set fits it still: every box filled and a box
       product it works with. */
    teklifHolds() {
      if (!this.teklif || !this.kademeLive()) return false;
      var card = this.teklifCard(this.teklif.productId);
      var self = this;
      return (
        !!card &&
        this.baseSlots().some(function (s) {
          return self.teklifFits(card, s);
        })
      );
    }

    teklifCut() {
      return this.teklif ? Math.round((this.teklif.price * this.teklifPct) / 100) : 0;
    }

    /* The offer's line: its units, one of them at the offer's price. */
    teklifSum() {
      return this.teklif ? this.teklif.price * units(this.teklif) - this.teklifCut() : 0;
    }

    /* The boxes changed: an offer that no longer fits goes. */
    pruneTeklif() {
      if (!this.teklif || this.teklifHolds()) return null;
      var gone = this.teklif;
      this.teklif = null;
      return gone;
    }

    /* No offer taken, but an added box of its type holds a consumable that
       fits (one added beside the offer, then the offer went): the first
       such is the offer now — its box gives way to the offer's row, at the
       offer's price. Returns it. */
    settleTeklif() {
      if (this.teklif || !this.teklifCat || !this.kademeLive()) return null;
      var self = this;
      var pool = this.teklifCat.pool;
      var slot = this.ekSlots()
        .filter(function (s) {
          return s.pool === pool && !!s.sel;
        })
        .sort(function (a, b) {
          return a.at - b.at;
        })
        .find(function (s) {
          var card = self.teklifCard(s.sel.productId);
          return (
            !!card &&
            self.baseSlots().some(function (b) {
              return self.teklifFits(card, b);
            })
          );
        });
      if (!slot) return null;
      this.teklif = slot.sel;
      this.removeEk(slot);
      return this.teklif;
    }

    settledNote(moved) {
      return moved ? ' %' + this.teklifPct + ' indirim artık ' + shortName(moved.title) + ' için.' : '';
    }

    /* The offer list's button of a product, for the focus once the list
       is rebuilt. */
    focusTeklif(productId) {
      if (!this.teklifEl) return;
      this.focusEl(this.teklifEl.querySelector('[data-xpk-teklif-item="' + productId + '"]') || this.summaryTitle);
    }

    onTeklifAdd(productId) {
      var card = this.teklifCard(productId);
      if (!card || this.teklif || !this.kademeLive()) return;
      this.teklif = this.cardPick(card);
      this.persist();
      this.note(shortName(this.teklif.title) + ' %' + this.teklifPct + ' indirimle ' + this.word('ine') + ' eklendi.');
      this.track('xset_teklif', { urun: this.teklif.handle });
      this.render();
      this.focusTeklif(productId);
    }

    /* The offer taken, another consumable of the list goes in beside it —
       as an added box of its type ("+"), at its own price. */
    onTeklifExtra(productId) {
      var card = this.teklifCard(productId);
      if (!card || !this.teklif) return;
      var slot = this.addEk(this.teklifCat.pool);
      if (!slot) {
        this.note(
          this.ekSlots().length >= this.ekMax
            ? 'En fazla ' + this.ekMax + ' ek ürün ekleyebilirsin.'
            : 'Bu türün bütün ürünleri ' + this.word('inde') + '.'
        );
        return;
      }
      slot.sel = this.cardPick(card);
      slot.at = ++this.clock;
      this.note(shortName(slot.sel.title) + ' ' + this.word('ine') + ' eklendi.');
      this.track('xset_teklif_ek', { urun: slot.sel.handle });
      this.afterChange(false);
      this.focusTeklif(productId);
    }

    /* The list's "Seçildi": the product goes — the offer, or the added box
       that holds it. */
    onTeklifDrop(productId) {
      if (this.teklif && String(this.teklif.productId) === String(productId)) {
        this.onTeklifRemove();
        this.focusTeklif(productId);
        return;
      }
      var pool = this.teklifCat ? this.teklifCat.pool : null;
      var slot = this.ekSlots().find(function (s) {
        return s.pool === pool && s.sel && String(s.sel.productId) === String(productId);
      });
      if (!slot) return;
      this.removeEk(slot);
      this.note(shortName(slot.sel.title) + ' ' + this.word('ten') + ' çıkarıldı.');
      this.afterChange(false);
      this.focusTeklif(productId);
    }

    onTeklifRemove() {
      if (!this.teklif) return;
      var gone = this.teklif;
      this.teklif = null;
      var moved = this.settleTeklif();
      this.persist();
      this.note(shortName(gone.title) + ' ' + this.word('ten') + ' çıkarıldı.' + this.settledNote(moved));
      this.render();
      this.focusEl(this.summaryTitle);
    }

    /* The summary row of the offer taken: its set price, out with ×. */
    teklifRow() {
      var tk = this.teklif;
      var tli = document.createElement('li');
      tli.className = 'xpk__sum-row xpk__sum-row--ek';
      var tthumb = document.createElement('img');
      tthumb.className = 'xpk__sum-thumb';
      tthumb.src = tk.img;
      tthumb.alt = '';
      tthumb.width = 40;
      tthumb.height = 40;
      var ttext = document.createElement('div');
      ttext.className = 'xpk__sum-text';
      var tcat = document.createElement('p');
      tcat.className = 'xpk__sum-cat';
      tcat.textContent = this.baseSlots().length + 1 + '. ürün · ' + (this.teklifCat ? this.teklifCat.name : 'Sarf malzemesi');
      var tdeal = document.createElement('span');
      tdeal.className = 'xpk__sum-tag';
      tdeal.textContent = dealText(this.teklifPct, units(tk));
      tcat.appendChild(tdeal);
      var tname = document.createElement('p');
      tname.className = 'xpk__sum-name';
      tname.textContent = tk.title;
      ttext.appendChild(tcat);
      ttext.appendChild(tname);
      if (this.qtyMax) {
        var tstep = this.stepperEl('xpk__qty--sum', TEKLIF_KEY);
        this.fillStepper(tstep, { sel: tk }, false);
        ttext.appendChild(tstep);
      }
      var tprice = document.createElement('p');
      tprice.className = 'xpk__sum-price';
      var tfull = document.createElement('s');
      tfull.textContent = money(tk.price * units(tk));
      tprice.appendChild(tfull);
      tprice.appendChild(document.createTextNode(' ' + money(this.teklifSum())));
      var tdrop = document.createElement('button');
      tdrop.type = 'button';
      tdrop.className = 'xpk__sum-edit xpk__sum-remove';
      tdrop.dataset.xpkTeklifRemove = '';
      tdrop.setAttribute('aria-label', shortName(tk.title) + ' ' + this.word('ten') + ' çıkar');
      tdrop.innerHTML =
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      tli.appendChild(tthumb);
      tli.appendChild(ttext);
      tli.appendChild(tprice);
      tli.appendChild(tdrop);
      return tli;
    }

    /* The summary's offer: the consumables that fit, each with "Sete ekle".
       One taken stays on the list as "Seçildi" (pressed again, it goes);
       the others stay too and go in beside it at their own price. Rebuilt
       only when they change (a rebuilt button drops the focus). */
    renderTeklif() {
      if (!this.teklifEl) return;
      var opts = this.showSummary ? this.teklifOptions() : [];
      var taken = !!this.teklif;
      var sig =
        (taken ? 't|' : '') +
        opts
          .map(function (o) {
            return o.card.dataset.variantId + ':' + o.card.dataset.price + ':' + (o.held ? (o.held.teklif ? 't' : 'e') : '');
          })
          .join(',');
      this.teklifEl.hidden = !opts.length;
      if (sig === this.teklifSig) return;
      this.teklifSig = sig;
      this.teklifEl.innerHTML = '';
      if (!opts.length) return;
      var self = this;
      var head = document.createElement('p');
      head.className = 'xpk__teklif-title';
      head.textContent =
        this.baseSlots().length + 1 + '. ürün: ' + this.word('ine') + ' uygun ' + (this.teklifCat.name || 'sarf malzemesi').toLocaleLowerCase('tr');
      var chip = document.createElement('span');
      chip.className = 'xpk__sum-tag';
      chip.textContent = '%' + this.teklifPct + ' İndirim';
      head.appendChild(chip);
      this.teklifEl.appendChild(head);
      // The offer taken: why the others now show their own price.
      if (
        taken &&
        opts.some(function (o) {
          return !o.held;
        })
      ) {
        var sub = document.createElement('p');
        sub.className = 'xpk__teklif-sub';
        sub.textContent = '%' + this.teklifPct + ' indirim tek ürüne uygulanır; diğerleri kendi fiyatıyla eklenir.';
        this.teklifEl.appendChild(sub);
      }
      var list = document.createElement('ul');
      list.className = 'xpk__teklif-list';
      list.setAttribute('role', 'list');
      opts.forEach(function (o) {
        var pick = self.cardPick(o.card);
        // At the offer's price: the offer itself, or any while it is free.
        var deal = (o.held && o.held.teklif) || (!o.held && !taken);
        var li = document.createElement('li');
        li.className = 'xpk__teklif-item';
        var img = document.createElement('img');
        img.className = 'xpk__sum-thumb';
        img.src = pick.img;
        img.alt = '';
        img.width = 40;
        img.height = 40;
        img.loading = 'lazy';
        var text = document.createElement('div');
        text.className = 'xpk__sum-text';
        var name = document.createElement('p');
        name.className = 'xpk__sum-name';
        name.textContent = pick.title;
        var fit = document.createElement('p');
        fit.className = 'xpk__teklif-fit';
        fit.textContent = shortName(o.fit.sel.title) + ' ile uyumlu';
        text.appendChild(name);
        text.appendChild(fit);
        var price = document.createElement('p');
        price.className = 'xpk__sum-price';
        if (deal) {
          var full = document.createElement('s');
          full.textContent = money(pick.price);
          price.appendChild(full);
          price.appendChild(document.createTextNode(' ' + money(pick.price - Math.round((pick.price * self.teklifPct) / 100))));
        } else {
          price.textContent = money(pick.price);
        }
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'xpk__teklif-add btn btn--outline';
        add.dataset.xpkTeklifItem = pick.productId;
        var label = document.createElement('span');
        label.className = 'btn__text';
        if (o.held) {
          // The store's "Seçildi": the filled button with a tick.
          add.classList.add('btn--active');
          add.dataset.xpkTeklifDrop = pick.productId;
          add.setAttribute('aria-pressed', 'true');
          add.setAttribute('aria-label', 'Seçildi, ' + self.word('ten') + ' çıkarmak için dokun: ' + shortName(pick.title));
          add.insertAdjacentHTML(
            'beforeend',
            '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 10.5l3.5 3.5 7.5-8"/></svg>'
          );
          label.textContent = 'Seçildi';
        } else {
          if (taken) {
            add.dataset.xpkTeklifExtra = pick.productId;
            add.setAttribute('aria-label', shortName(pick.title) + ': ' + self.word('ine') + ' ekle');
          } else {
            add.dataset.xpkTeklifAdd = pick.productId;
            add.setAttribute('aria-label', shortName(pick.title) + ': %' + self.teklifPct + ' indirimle ' + self.word('ine') + ' ekle');
          }
          label.textContent = self.noun === 'set' ? 'Sete ekle' : 'Pakete ekle';
        }
        add.appendChild(label);
        li.appendChild(img);
        li.appendChild(text);
        li.appendChild(price);
        li.appendChild(add);
        list.appendChild(li);
      });
      this.teklifEl.appendChild(list);
    }

    /* ------------------------------------------------- box set discount */

    /* A box's set discount (parseDeal): a required box by its place among
       them, an added box by its type's own (ek_tur "indirim"). */
    baseDeal(slot) {
      if (!this.kademeOn || !slot || slot.gift) return null;
      if (slot.ek) return this.ekDeal(slot.pool);
      return this.kademe[this.baseSlots().indexOf(slot)] || null;
    }

    /* What a filled box gets: its product's own discount, else the box's. */
    kademeDeal(slot) {
      var own = this.kademeOn && slot && slot.sel && !slot.gift ? this.urunDeal(slot.pool, slot.sel.productId) : undefined;
      return own === undefined ? this.baseDeal(slot) : own;
    }

    /* A product's own discount in a row (parseDeal; null = none there),
       undefined when it has none of its own. */
    urunDeal(pool, productId) {
      var cat = this.cats.find(function (c) {
        return c.pool === pool && c.urun;
      });
      var id = String(productId);
      if (!cat || productId == null || !Object.prototype.hasOwnProperty.call(cat.urun, id)) return undefined;
      return parseDeal(cat.urun[id]);
    }

    /* A card's set discount: its product's own, else its row's. */
    cardDeal(card) {
      if (!this.kademeOn || card.dataset.gift === 'true') return null;
      var pool = card.dataset.pool;
      var own = this.urunDeal(pool, card.dataset.productId);
      if (own !== undefined) return own;
      var box = this.baseSlots().find(function (s) {
        return s.pool === pool;
      });
      return box ? this.baseDeal(box) : this.ekDeal(pool);
    }

    /* The chip of a row whose products have discounts of their own: one
       discount when every card gives it, a range of percents, else that
       some products have one (each card shows its own). */
    rowDealText(cat) {
      var self = this;
      var deals = Array.prototype.map.call(cat.el.querySelectorAll('[data-xpk-card]'), function (card) {
        return self.cardDeal(card);
      });
      var on = deals.filter(Boolean);
      if (!on.length) return '';
      var labels = on.map(dealLabel);
      var same = labels.every(function (l) {
        return l === labels[0];
      });
      if (on.length < deals.length) return 'Ürüne özel indirim';
      if (same) return labels[0] + ' İndirim';
      var pcts = on.every(function (d) {
        return !d.tl;
      });
      if (!pcts) return 'Ürüne özel indirim';
      var ps = on.map(function (d) {
        return d.pct;
      });
      return '%' + Math.min.apply(null, ps) + '–%' + Math.max.apply(null, ps) + ' İndirim';
    }

    /* A "+" type's set discount (data-indirim on its row), null for none. */
    ekDeal(pool) {
      var cat = this.cats.find(function (c) {
        return c.ek && c.pool === pool;
      });
      return cat ? parseDeal(cat.el.dataset.indirim) : null;
    }

    /* It comes off once every required box is filled — and not off a
       ready set, which has its own price. */
    kademeLive() {
      if (!this.kademeOn) return false;
      var empty = this.baseSlots().some(function (s) {
        return !s.sel;
      });
      return !empty && !this.readyState().match;
    }

    /* The amount off one box: one unit, rounded to the kuruş as the cart's
       discount is. */
    kademeCut(slot) {
      var deal = this.kademeDeal(slot);
      return deal && slot.sel ? dealCut(slot.sel.price, deal) : 0;
    }

    /* A card's price: a discounted box's row shows the struck price and the
       set price (the gift's own markup stays). */
    cardPrice(card) {
      var el = card.querySelector('[data-xpk-card-price]');
      if (!el || card.dataset.gift === 'true') return;
      var price = parseInt(card.dataset.price, 10) || 0;
      var deal = this.cardDeal(card);
      el.classList.toggle('xpk__card-price--deal', !!deal);
      if (!deal) {
        setText(el, money(price));
        return;
      }
      el.textContent = '';
      var was = document.createElement('s');
      was.className = 'xpk__card-was';
      was.textContent = money(price);
      var now = document.createElement('span');
      now.className = 'xpk__card-now';
      now.textContent = money(price - dealCut(price, deal));
      el.appendChild(was);
      el.appendChild(document.createTextNode(' '));
      el.appendChild(now);
    }

    kademeSum() {
      if (!this.kademeLive()) return 0;
      var self = this;
      return this.baseSlots()
        .concat(this.ekSlots())
        .reduce(function (n, s) {
          return n + self.kademeCut(s);
        }, 0);
    }

    /* The cart lines: a ready set as one line of its own product and the
       rest beside it, else one line per selection. */
    planLines() {
      var st = this.readyState();
      var sels = this.allSels();
      if (!st.match) return { set: null, inSet: [], lines: sels };
      return {
        set: st.match,
        inSet: sels.filter(function (x, i) {
          return st.taken.indexOf(i) !== -1;
        }),
        lines: sels.filter(function (x, i) {
          return st.taken.indexOf(i) === -1;
        }),
      };
    }

    /* What the set line added belongs to its set: once the boxes change so
       that it is in the set no more (another fountain — the old one's
       filter), it goes, so a filter that fits nothing never reaches the
       cart. Returns what went. */
    pruneExtras() {
      if (!this.extras.length) return [];
      var sels = this.allSels();
      var r = this.readyMatchFor(sels);
      var first = sels.length - this.extras.length;
      var keep = [];
      var gone = [];
      this.extras.forEach(function (x, j) {
        if (r.match && r.taken.indexOf(first + j) !== -1) keep.push(x);
        else gone.push(x);
      });
      this.extras = keep;
      if (gone.length) {
        this.readyCache = null;
        if (
          this.freeHint &&
          !keep.some(function (x) {
            return x.productId === this.freeHint;
          }, this)
        ) {
          this.freeHint = '';
        }
      }
      return gone;
    }

    /* ---------------------------------------------------------- actions */

    onPick(card) {
      this.hideTip(true);
      if (card.dataset.gift === 'true' && this.giftLocked()) return this.giftWait();
      var pool = card.dataset.pool;
      var pick = this.cardPick(card);
      var boxes = this.activeIn(pool);
      var target = this.targetKey ? this.slotByKey(this.targetKey) : null;
      if (target && target.pool !== pool) target = null;
      var held = this.slotOfGroup(pool, pick.group);

      // The model is already in a box of this row.
      if (held) {
        if (held.sel.variantId === pick.variantId) {
          // Same colour: "Seçildi" pressed — take it out.
          held.sel = null;
          this.targetKey = held.key;
          this.note(shortName(pick.title) + ' ' + this.word('ten') + ' çıkarıldı.');
          this.afterChange(false);
          return;
        }
        if (target && target !== held) {
          // Aimed at the other box with the same model in a new colour.
          var kind = shortName(held.label).replace(/\s*\d+$/, '').toLocaleLowerCase('tr');
          this.note('Bu model ' + (held.index + 1) + '. kutucukta; iki ' + kind + ' farklı ürün olmalı.');
          return;
        }
        // The units go with the model to its new colour, within its stock.
        if (this.qtyMax) pick.qty = Math.min(units(held.sel), this.qtyCap(pick));
        held.sel = pick;
        held.at = ++this.clock;
        this.targetKey = null;
        this.note(shortName(pick.title) + ': renk değişti.');
        this.afterChange(false);
        return;
      }

      if (!target) {
        target = boxes.find(function (s) {
          return !s.sel;
        });
      }
      if (!target && boxes.length) {
        // A full row: the retailer's page replaces the pick. With two boxes
        // in the row, the one filled last.
        target = boxes.slice().sort(function (a, b) {
          return b.at - a.at;
        })[0];
      }
      if (!target) return;
      var replaced = target.sel;
      target.sel = pick;
      target.at = ++this.clock;
      this.targetKey = null;
      var names = replaced ? namePair(replaced.title, pick.title) : null;
      this.note(names ? names[0] + ' yerine ' + names[1] + ' seçildi.' : shortName(pick.title) + ' ' + this.word('ine') + ' eklendi.');
      this.track('xset_pick', { adim: target.key, urun: pick.handle });
      this.afterChange(true, target);
    }

    afterChange(advance, filled) {
      // A box changed: what the set line added may fit nothing now, nor the
      // offer.
      var gone = this.pruneExtras();
      var teklifGone = this.pruneTeklif();
      if (teklifGone) gone = gone.concat([teklifGone]);
      // An added consumable that fits takes the free offer place.
      var moved = this.settleTeklif();
      if (gone.length) {
        var said = this.noteEl ? this.noteEl.textContent : '';
        var names = gone
          .map(function (x) {
            return x.short || shortName(x.title);
          })
          .join(', ');
        this.note((said ? said + ' ' : '') + names + ' ' + this.word('ten') + ' çıkarıldı.');
      }
      if (moved) this.note(((this.noteEl ? this.noteEl.textContent : '') + this.settledNote(moved)).trim());
      this.persist();
      var wasSummary = this.showSummary;
      this.showSummary = this.complete() && !this.targetKey;
      this.render();
      if (this.showSummary && !wasSummary) {
        this.track('xset_complete', {});
        this.scrollToEl(this, true);
        this.focusEl(this.summaryTitle);
        return;
      }
      if (!advance || !filled) return;
      // The row still has an empty box: stay. Else the next row that does.
      var rowLeft = this.activeIn(filled.pool).some(function (s) {
        return !s.sel;
      });
      if (rowLeft) return;
      var next = this.firstEmpty();
      if (next && next.gift) this.note(this.word('in', true) + ' tamam — şimdi hediyeni seç.');
      if (next) this.scrollToPool(next.pool, true);
    }

    /* A gift asked for before the paid boxes are filled: say so and go to
       the first box still empty. */
    giftWait() {
      var next = this.baseSlots().find(function (s) {
        return !s.sel;
      });
      this.note('Hediyeni seçmek için önce ' + (next ? shortName(next.label) : 'paketindeki ürünleri') + ' seç.');
      if (next) this.scrollToPool(next.pool, true);
    }

    /* ------------------------------------------------------------- adet */

    /* The most units of a pick a box may hold: the page's maximum, or the
       variant's stock when that is less (tracked, cannot be oversold). */
    qtyCap(sel) {
      var stok = (sel && sel.stok) || 0;
      return stok > 0 && stok < this.qtyMax ? stok : this.qtyMax;
    }

    /* The units of a box (by its key) or of the summary's offer
       (TEKLIF_KEY), one up or down; never under one (the card's bin, the
       summary's pencil and × take the product out). The gift is one. */
    onQty(key, delta) {
      var slot = key === TEKLIF_KEY ? null : this.slotByKey(key);
      var sel = slot ? slot.sel : key === TEKLIF_KEY ? this.teklif : null;
      if (!this.qtyMax || !sel || (slot && slot.gift)) return;
      var name = shortName(sel.title);
      var n = units(sel) + delta;
      if (n < 1) return;
      var cap = this.qtyCap(sel);
      if (n > cap) {
        this.note(cap < this.qtyMax ? name + ': stokta ' + cap + ' adet var.' : 'Bir üründen en fazla ' + cap + ' adet ekleyebilirsin.');
        return;
      }
      var next = Object.assign({}, sel, { qty: n });
      if (slot) slot.sel = next;
      else this.teklif = next;
      // A discounted line: the discount is on one unit (the cart's).
      var deal = slot ? (this.kademeLive() ? this.kademeDeal(slot) : null) : this.teklifPct;
      this.note(name + ': ' + n + ' adet.' + (deal && n > 1 ? ' ' + dealLabel(deal) + ' indirim 1 adede, diğerleri kendi fiyatıyla.' : ''));
      this.track('xset_adet', { adim: key, urun: next.handle, adet: n });
      this.persist();
      this.render();
    }

    /* A stepper's press: a card's speaks for the box holding its colour,
       a summary row's for its key. */
    onQtyBtn(btn) {
      this.hideTip(true);
      var delta = parseInt(btn.dataset.xpkQty, 10) || 0;
      var card = btn.closest('[data-xpk-card]');
      if (!card) {
        // The summary is drawn again: the focus comes back to the button.
        var key = btn.dataset.key;
        this.onQty(key, delta);
        if (this.summaryList) {
          this.focusEl(this.summaryList.querySelector('[data-xpk-qty="' + delta + '"][data-key="' + key + '"]'));
        }
        return;
      }
      var held = this.slotOfGroup(card.dataset.pool, card.dataset.group);
      if (!held || held.sel.variantId !== card.dataset.variantId) return;
      if (delta < 0 && units(held.sel) <= 1) {
        // The bin at one unit: "Seçildi" pressed — the product goes.
        this.onPick(card);
        this.focusEl(card.querySelector('[data-xpk-pick]'));
        return;
      }
      this.onQty(held.key, delta);
    }

    /* "− 1 adet +". The summary's buttons carry their box key; a card's
       find their box through the card. */
    stepperEl(mod, key) {
      var box = document.createElement('div');
      box.className = 'xpk__qty ' + mod;
      box.dataset.xpkQtyBox = '';
      box.setAttribute('role', 'group');
      var minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'xpk__qty-btn xpk__qty-minus';
      minus.dataset.xpkQty = '-1';
      minus.innerHTML =
        '<svg class="xpk__qty-dec" viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 10h10"/></svg>' +
        '<svg class="xpk__qty-bin" viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.8 4.5h10.4M6.3 4.5V3h3.4v1.5M4.4 4.5l.6 8.3a1 1 0 0 0 1 .9h4a1 1 0 0 0 1-.9l.6-8.3M6.8 7v4.3M9.2 7v4.3"/></svg>';
      var num = document.createElement('span');
      num.className = 'xpk__qty-num';
      num.dataset.xpkQtyNum = '';
      num.setAttribute('aria-live', 'polite');
      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'xpk__qty-btn xpk__qty-plus';
      plus.dataset.xpkQty = '1';
      plus.setAttribute('aria-label', 'Bir adet artır');
      plus.innerHTML =
        '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 10h10M10 5v10"/></svg>';
      if (key) {
        minus.dataset.key = key;
        plus.dataset.key = key;
      }
      box.appendChild(minus);
      box.appendChild(num);
      box.appendChild(plus);
      return box;
    }

    /* The stepper says the box's units. canDrop (a card): at one unit "−"
       is the bin; else it is off there. */
    fillStepper(box, slot, canDrop) {
      var n = units(slot.sel);
      var name = shortName(slot.sel.title);
      var drop = canDrop && n <= 1;
      box.setAttribute('aria-label', name + ' adedi');
      box.classList.toggle('is-one', drop);
      setText(box.querySelector('[data-xpk-qty-num]'), n + ' adet');
      var minus = box.querySelector('[data-xpk-qty="-1"]');
      minus.setAttribute('aria-label', drop ? name + ' ' + this.word('ten') + ' çıkar' : 'Bir adet azalt');
      setOff(minus, !canDrop && n <= 1);
      setOff(box.querySelector('[data-xpk-qty="1"]'), n >= this.qtyCap(slot.sel));
    }

    /* ----------------------------------------------------------- ek (+) */

    ekCat(pool) {
      return (
        this.cats.find(function (c) {
          return c.ek && c.pool === pool;
        }) || null
      );
    }

    /* One more box of the type `pool`: its head box before "+", its row on
       show under the last row on show. null when there is no room — the
       page's maximum, or every model of the type already in a box. */
    addEk(pool, key) {
      var cat = this.ekCat(pool);
      if (!cat || !this.ekTpl || !this.slotsEl) return null;
      if (this.ekSlots().length >= this.ekMax) return null;
      if (this.activeIn(pool).length >= cat.models) return null;
      var n = parseInt(String(key || '').replace(/^ek/, ''), 10);
      if (!key || !n || this.slotByKey(key)) {
        do {
          this.ekSeq += 1;
          key = 'ek' + this.ekSeq;
        } while (this.slotByKey(key));
      } else if (n > this.ekSeq) {
        this.ekSeq = n;
      }
      var li = this.ekTpl.content.firstElementChild.cloneNode(true);
      var el = li.querySelector('[data-xpk-slot]');
      el.dataset.key = key;
      el.dataset.pool = pool;
      el.dataset.label = cat.name;
      this.slotsEl.insertBefore(li, this.addTile || null);
      var slot = { el: el, key: key, pool: pool, label: cat.name, gift: false, ek: true, index: this.slots.length, sel: null, at: 0 };
      this.slots.push(slot);
      if (cat.el.hidden) {
        cat.el.hidden = false;
        // Under the last row on show: the added rows read in the order added.
        if (this.catsEl) this.catsEl.appendChild(cat.el);
        this.cats = this.cats
          .filter(function (c) {
            return c !== cat;
          })
          .concat([cat]);
      }
      return slot;
    }

    removeEk(slot) {
      var li = slot.el.closest('li');
      if (li) li.remove();
      this.slots = this.slots.filter(function (s) {
        return s !== slot;
      });
      this.slots.forEach(function (s, i) {
        s.index = i;
      });
      if (this.targetKey === slot.key) this.targetKey = null;
      var cat = this.ekCat(slot.pool);
      if (cat && !this.slotsOf(slot.pool).length) {
        cat.el.hidden = true;
        if (this.viewPool === slot.pool) this.viewPool = this.cats.length ? this.cats[0].pool : null;
      }
    }

    setAddOpen(show) {
      if (!this.addTypesEl) return;
      this.addTypesEl.hidden = !show;
      var trigger = this.addEl.querySelector('.xpk__add-open');
      if (trigger) trigger.setAttribute('aria-expanded', show ? 'true' : 'false');
    }

    /* "+": the type question where the rows (or the summary) end. The head's
       "+" opens it and goes there; the button under the rows toggles it. */
    onAddOpen(btn) {
      this.hideTip(true);
      if (!this.addEl || !this.addTypesEl) return;
      if (this.ekSlots().length >= this.ekMax) {
        this.note('En fazla ' + this.ekMax + ' ek ürün ekleyebilirsin.');
        return;
      }
      var fromHead = !this.addEl.contains(btn);
      this.setAddOpen(fromHead ? true : this.addTypesEl.hidden);
      if (!fromHead) return;
      this.scrollToEl(this.addEl);
      var first = this.addTypesEl.querySelector('[data-xpk-add-type]:not([disabled]):not([hidden])');
      if (first) this.focusEl(first);
    }

    onAddType(pool) {
      var cat = this.ekCat(pool);
      var slot = this.addEk(pool);
      if (!slot) {
        this.note(
          this.ekSlots().length >= this.ekMax
            ? 'En fazla ' + this.ekMax + ' ek ürün ekleyebilirsin.'
            : 'Bu türün bütün ürünleri ' + this.word('inde') + '.'
        );
        this.render();
        return;
      }
      this.setAddOpen(false);
      this.targetKey = slot.key;
      this.showSummary = false;
      this.viewPool = pool;
      this.persist();
      this.note(cat.name + ': ' + this.word('ine') + ' eklemek istediğin ürünü seç.');
      this.track('xset_ek_kutu', { tur: cat.name });
      this.render();
      this.syncCardColours();
      this.scrollToPool(pool, true);
    }

    /* A row's "Kaldır": its empty box if it has one, else the one filled
       last. */
    onEkDrop(pool) {
      var boxes = this.slotsOf(pool).filter(function (s) {
        return s.ek;
      });
      if (!boxes.length) return;
      var slot =
        boxes
          .filter(function (s) {
            return !s.sel;
          })
          .pop() ||
        boxes.slice().sort(function (a, b) {
          return b.at - a.at;
        })[0];
      var cat = this.ekCat(pool);
      this.removeEk(slot);
      this.note((slot.sel ? shortName(slot.sel.title) : cat.name + ' kutusu') + ' ' + this.word('ten') + ' çıkarıldı.');
      this.afterChange(false);
      if (!this.showSummary && cat.el.hidden && this.addEl) this.scrollToEl(this.addEl);
    }

    /* A box's bin: the box empties and the step line asks for it again;
       an added box goes altogether (the summary's ×). */
    onSlotClear(slot) {
      this.hideTip(true);
      if (slot.ek) {
        this.onEkRemove(slot.key);
        // The box is gone with its bin: focus goes to "+".
        if (!this.showSummary && this.addTile && !this.addTile.hidden) this.focusEl(this.addTile.querySelector('button'));
        return;
      }
      if (!slot.sel) return;
      var gone = slot.sel;
      slot.sel = null;
      this.targetKey = slot.key;
      this.viewPool = slot.pool;
      this.note(shortName(gone.title) + ' ' + this.word('ten') + ' çıkarıldı.');
      this.track('xset_unpick', { adim: slot.key, urun: gone.handle });
      this.afterChange(false);
      this.syncCardColours();
      // The bin hides with the product: focus stays on the box.
      this.focusEl(slot.el);
    }

    /* The summary's "Sıfırla": every box empty, the added boxes and what
       the set line added gone, back to the first row. The note's "Geri al"
       brings the package back while it is on screen. */
    onReset() {
      this.hideTip(true);
      var snap = {
        picks: this.slots.map(function (s) {
          return { key: s.key, ek: !!s.ek, pool: s.pool, sel: s.sel, at: s.at };
        }),
        extras: this.extras.slice(),
        freeHint: this.freeHint,
        teklif: this.teklif,
      };
      var had =
        snap.extras.length ||
        snap.picks.some(function (x) {
          return !!x.sel;
        });
      if (!had) return;
      var self = this;
      this.ekSlots().forEach(function (s) {
        self.removeEk(s);
      });
      this.slots.forEach(function (s) {
        s.sel = null;
        s.at = 0;
      });
      this.extras = [];
      this.freeHint = '';
      this.teklif = null;
      this.readyCache = null;
      this.targetKey = null;
      this.showSummary = false;
      if (this.addTypesEl) this.setAddOpen(false);
      this.viewPool = this.cats.length ? this.cats[0].pool : null;
      this.persist();
      this.track('xset_reset', {});
      this.render();
      this.syncCardColours();
      this.noteUndo(this.word('in', true) + ' sıfırlandı.', snap);
      var first = this.cats.find(function (c) {
        return !c.el.hidden;
      });
      if (first) {
        this.scrollToEl(first.el, false);
        this.focusEl(first.title);
      }
    }

    onUndoReset() {
      var snap = this.resetSnap;
      if (!snap) return;
      var self = this;
      // What was picked since the reset gives way to the package as it was.
      this.ekSlots().forEach(function (s) {
        self.removeEk(s);
      });
      this.slots.forEach(function (s) {
        s.sel = null;
      });
      snap.picks.forEach(function (x) {
        var slot = x.ek ? self.addEk(x.pool, x.key) : self.slotByKey(x.key);
        if (!slot) return;
        slot.sel = x.sel;
        slot.at = x.at;
      });
      this.extras = snap.extras;
      this.freeHint = snap.freeHint;
      this.teklif = snap.teklif || null;
      this.readyCache = null;
      this.targetKey = null;
      this.showSummary = this.complete();
      this.persist();
      this.note(this.word('in', true) + ' geri geldi.');
      this.render();
      this.syncCardColours();
      if (this.showSummary) {
        this.scrollToEl(this, true);
        this.focusEl(this.summaryTitle);
      }
    }

    /* A note with "Geri al", on screen a little longer than a plain one. */
    noteUndo(text, snap) {
      if (!this.noteEl) return;
      this.note('');
      this.resetSnap = snap;
      this.noteEl.appendChild(document.createTextNode(text + ' '));
      var undo = document.createElement('button');
      undo.type = 'button';
      undo.className = 'xpk__undo';
      undo.dataset.xpkUndo = '';
      undo.textContent = 'Geri al';
      this.noteEl.appendChild(undo);
      this.noteEl.classList.add('is-on', 'has-undo');
      clearTimeout(this.noteTimer);
      var self = this;
      this.noteTimer = setTimeout(function () {
        self.note('');
      }, 10000);
    }

    /* The summary's × of an added product. */
    onEkRemove(key) {
      var slot = this.slotByKey(key);
      if (!slot || !slot.ek) return;
      this.removeEk(slot);
      this.note((slot.sel ? shortName(slot.sel.title) : slot.label + ' kutusu') + ' ' + this.word('ten') + ' çıkarıldı.');
      this.afterChange(false);
      if (this.showSummary) this.focusEl(this.summaryTitle);
    }

    /* "+" goes at the maximum; a type whose every model is in a box is off. */
    renderAdd() {
      if (!this.addEl) return;
      var self = this;
      // No type with a model in stock: no "+" at all.
      var anyType = this.cats.some(function (c) {
        return c.ek && c.models > 0;
      });
      this.addEl.hidden = !anyType;
      if (!anyType) {
        if (this.addTile) this.addTile.hidden = true;
        return;
      }
      var full = this.ekSlots().length >= this.ekMax;
      if (this.addTile) this.addTile.hidden = full;
      var trigger = this.addEl.querySelector('.xpk__add-open');
      if (trigger) trigger.hidden = full;
      if (this.addMaxEl) this.addMaxEl.hidden = !full;
      if (full) this.setAddOpen(false);
      Array.prototype.forEach.call(this.addEl.querySelectorAll('[data-xpk-add-type]'), function (b) {
        var cat = self.ekCat(b.dataset.xpkAddType);
        b.hidden = !cat || !cat.models;
        b.disabled = !cat || self.activeIn(cat.pool).length >= cat.models;
      });
      this.cats.forEach(function (cat) {
        if (!cat.ek || !cat.ekCount) return;
        var n = self.activeIn(cat.pool).length;
        setText(cat.ekCount, n > 1 ? ' · ' + n + ' ürün seç' : '');
      });
      if (this.slotsEl) {
        var tiles = this.slotsEl.querySelectorAll('.xpk__slot-item:not([hidden])').length;
        this.slotsEl.classList.toggle('is-many', tiles > 5);
      }
    }

    onSlot(slot) {
      this.hideTip(true);
      if (slot.gift && this.giftLocked()) return this.giftWait();
      this.targetKey = slot.key;
      this.showSummary = false;
      this.viewPool = slot.pool;
      this.render();
      this.syncCardColours();
      this.scrollToPool(slot.pool, true);
    }

    onBack() {
      this.showSummary = false;
      this.targetKey = null;
      this.render();
      this.syncCardColours();
      var first = this.cats.find(function (c) {
        return !c.el.hidden;
      });
      if (first) {
        this.viewPool = first.pool;
        this.render();
        this.scrollToEl(first.el, false);
        this.focusEl(first.title);
      }
    }

    onCta() {
      if (this.busy) return;
      if (!this.complete()) {
        var next = this.firstEmpty();
        if (next) {
          this.note(
            next.ek
              ? 'Eklediğin ' + shortName(next.label) + ' kutusu boş: bir ürün seç ya da kutuyu kaldır.'
              : this.word('in', true) + ' tamamlanması için ' + (next.gift ? 'hediyeni' : shortName(next.label)) + ' seç.'
          );
          this.targetKey = null;
          this.showSummary = false;
          this.render();
          this.scrollToPool(next.pool, true);
        }
        return;
      }
      if (this.cartSigs[this.sig()]) return this.openCart();
      if (Object.keys(this.cartSigs).length >= MAX_SETS) {
        this.note('Sepette en fazla ' + MAX_SETS + ' ' + (this.family || '') + ' ' + this.word('i') + ' olabilir.');
        return;
      }
      this.addToCart();
    }

    /* Puts a card on one of its colours: picture, price, name, links. */
    applyColour(card, index) {
      if (!card.dataset.colors) return false;
      var colors;
      try {
        colors = JSON.parse(card.dataset.colors);
      } catch (e) {
        return false;
      }
      var c = colors[index];
      if (!c) return false;
      card.dataset.handle = c.h;
      card.dataset.productId = String(c.pid);
      card.dataset.variantId = String(c.vid);
      card.dataset.price = String(c.p);
      if (c.q != null) card.dataset.stok = String(c.q);
      else delete card.dataset.stok;
      card.dataset.img = c.img || card.dataset.img;
      card.dataset.title = c.t || card.dataset.title;
      var img = card.querySelector('.xpk__card-media img');
      if (img && c.img) {
        img.removeAttribute('srcset');
        img.src = c.img;
        img.alt = c.t || img.alt;
      }
      this.cardPrice(card);
      var link = card.querySelector('[data-xpk-card-link]');
      if (link) setText(link, c.t || link.textContent);
      // "Görüntüle" previews the colour on show.
      var view = card.querySelector('[data-xpk-view]');
      if (view) {
        view.dataset.setItem = c.h;
        view.setAttribute('aria-label', shortName(c.t || '') + ' — detayları gör');
      }
      Array.prototype.forEach.call(card.querySelectorAll('[data-xpk-swatch]'), function (s) {
        var on = (parseInt(s.dataset.index, 10) || 0) === index;
        s.classList.toggle('is-current', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      return true;
    }

    onSwatch(btn) {
      var card = btn.closest('[data-xpk-card]');
      if (!card) return;
      if (this.applyColour(card, parseInt(btn.dataset.index, 10) || 0)) this.renderCards();
    }

    /* A held colour that is not the card's own shows on its card (after a
       reload, a link, or coming back from the summary), so the card says
       "Seçildi" for what the box really holds. */
    syncCardColours() {
      var self = this;
      Array.prototype.forEach.call(this.querySelectorAll('[data-xpk-card][data-colors]'), function (card) {
        var held = self.slotOfGroup(card.dataset.pool, card.dataset.group);
        if (!held || held.sel.variantId === card.dataset.variantId) return;
        try {
          var colors = JSON.parse(card.dataset.colors);
          for (var i = 0; i < colors.length; i += 1) {
            if (String(colors[i].vid) === String(held.sel.variantId)) {
              self.applyColour(card, i);
              break;
            }
          }
        } catch (e) {
          /* the card keeps its colour */
        }
      });
      this.renderCards();
    }

    /* ------------------------------------------------------------ render */

    render() {
      var act = this.activeSlots();
      var current = this.complete() && !this.targetKey ? null : this.currentSlot();
      var outOf = ' ' + this.word('ten') + ' çıkar';

      this.slots.forEach(function (s) {
        var full = !!s.sel;
        // The bin: on a filled box; on an added box always (it takes the box).
        var del = s.el.parentNode && s.el.parentNode.querySelector('[data-xpk-slot-del]');
        if (del) {
          del.hidden = !full && !s.ek;
          del.setAttribute('aria-label', (full ? shortName(s.sel.title) : s.label + ' kutusunu') + outOf);
        }
        s.el.classList.toggle('is-filled', full);
        s.el.classList.toggle('is-active', !!current && current === s);
        var empty = s.el.querySelector('.xpk__slot-empty');
        var fullEl = s.el.querySelector('.xpk__slot-full');
        if (empty) empty.hidden = full;
        if (fullEl) fullEl.hidden = !full;
        var img = s.el.querySelector('[data-xpk-slot-img]');
        if (img) {
          if (full && img.getAttribute('src') !== s.sel.img) img.src = s.sel.img;
          img.alt = full ? s.sel.title : '';
        }
        // "×3" on a box holding several units.
        var n = full ? units(s.sel) : 1;
        var badge = s.el.querySelector('[data-xpk-slot-qty]');
        if (n > 1 && !badge && fullEl) {
          badge = document.createElement('span');
          badge.className = 'xpk__slot-qty';
          badge.dataset.xpkSlotQty = '';
          badge.setAttribute('aria-hidden', 'true');
          fullEl.appendChild(badge);
        }
        if (badge) {
          badge.hidden = n < 2;
          setText(badge, '×' + n);
        }
        s.el.setAttribute(
          'aria-label',
          s.index + 1 +
            '. ürün, ' +
            s.label +
            (full ? ': ' + shortName(s.sel.title) + (n > 1 ? ', ' + n + ' adet' : '') + '. Değiştirmek için dokun.' : ': seç')
        );
      });

      // "2. Adım: Hava & Zemin Seç" — or the package is done.
      if (current) {
        setText(this.stepNumEl, act.indexOf(current) + 1 + '. Adım:');
        if (current.gift) setText(this.stepTextEl, current.sel ? 'Hediyeni Değiştir' : 'Hediyeni Seç');
        else setText(this.stepTextEl, current.label + (current.sel ? ' Değiştir' : ' Seç'));
      } else {
        setText(this.stepNumEl, this.word('in', true) + ' hazır:');
        setText(this.stepTextEl, 'Sepete ekleyebilirsin');
      }

      var done = this.filledCount();
      if (this.progressEl) this.progressEl.style.width = (act.length ? (done / act.length) * 100 : 0) + '%';

      // The left picture follows the row the shopper is on.
      this.renderIntro(current);

      // The gift is free and counted apart: "3/3 ürün + hediye". Added
      // boxes join the count once the required ones are done ("5 ürün").
      var paidDone = this.paidSlots().filter(function (s) {
        return !!s.sel;
      }).length;
      var base = this.baseSlots();
      var baseDone = base.filter(function (s) {
        return !!s.sel;
      }).length;
      var gift = this.giftSlot();
      setText(this.totalEl, paidDone ? money(this.payTotal()) : '—');
      // A box of several units counts each ("3/3 ürün" → "5 ürün").
      var paidUnits = this.paidSlots().reduce(function (n, s) {
        return n + (s.sel ? units(s.sel) : 0);
      }, 0);
      var more = paidUnits - baseDone + (this.teklif ? units(this.teklif) : 0);
      var count = more && baseDone === base.length ? baseDone + more + ' ürün' : baseDone + '/' + base.length + ' ürün';
      // With what the set line added: the products the cart gets ("4 ürün").
      setText(
        this.countEl,
        this.extras.length ? paidUnits + this.extras.length + ' ürün' : count + (gift && gift.sel ? ' + hediye' : '')
      );
      this.renderGain();
      this.renderAdd();

      // The gift's box and row wait for the paid boxes.
      var locked = this.giftLocked();
      if (gift) gift.el.classList.toggle('is-locked', locked);
      var hintOpen = this.word('in', true) + ' tamam — hediyeni seç; ücretsiz.';
      this.cats.forEach(function (cat) {
        if (!cat.gift) return;
        cat.el.classList.toggle('is-locked', locked);
        if (cat.hint) setText(cat.hint, locked ? cat.hintLocked : hintOpen);
      });
      var ready = this.complete();
      var inCart = ready && !!this.cartSigs[this.sig()];
      if (this.ctaEl) {
        this.ctaEl.classList.toggle('is-ready', ready);
        // The store's own buttons: outlined until the set can go to the
        // cart, then the filled primary one.
        this.ctaEl.classList.toggle('btn--primary', ready);
        this.ctaEl.classList.toggle('btn--outline', !ready);
        this.ctaEl.classList.toggle('is-in-cart', inCart);
      }
      if (!this.busy) setText(this.ctaLabelEl, inCart ? 'Sepette ✓ · Sepete git' : this.ctaText);

      this.classList.toggle('is-summary', this.showSummary);
      if (this.catsEl) this.catsEl.hidden = this.showSummary;
      if (this.summaryEl) {
        this.summaryEl.hidden = !this.showSummary;
        if (this.showSummary) this.renderSummary();
      }
      this.renderTeklif();
      this.renderReady();
      this.renderCards();
    }

    renderIntro(current) {
      if (!this.introImg) return;
      var src = '';
      var pool = (current && current.pool) || this.viewPool;
      if (current && current.sel) src = current.sel.img;
      if (!src && pool) {
        var cat = this.cats.find(function (c) {
          return c.pool === pool;
        });
        var card = cat && cat.el.querySelector('[data-xpk-card]');
        if (card) src = card.dataset.img;
      }
      if (!src) {
        this.introImg.hidden = true;
        return;
      }
      if (this.introImg.getAttribute('src') !== src) this.introImg.src = src;
      this.introImg.hidden = false;
    }

    renderCards() {
      var self = this;
      Array.prototype.forEach.call(this.querySelectorAll('[data-xpk-card]'), function (card) {
        var pool = card.dataset.pool;
        var held = self.slotOfGroup(pool, card.dataset.group);
        var sameColour = !!held && held.sel.variantId === card.dataset.variantId;
        card.classList.toggle('is-selected', !!held);
        var giftCard = card.dataset.gift === 'true';
        var locked = giftCard && self.giftLocked();
        var label = giftCard ? 'Hediyeni Seç' : 'Ürünü Seç';
        if (held) label = sameColour ? 'Seçildi' : 'Bu rengi seç';
        card.classList.toggle('is-locked', locked);
        var btn = card.querySelector('[data-xpk-pick]');
        setText(card.querySelector('[data-xpk-pick-label]'), label);
        if (btn) {
          btn.classList.toggle('is-selected', sameColour);
          btn.classList.toggle('btn--active', sameColour);
          btn.setAttribute('aria-pressed', sameColour ? 'true' : 'false');
          if (locked) btn.setAttribute('aria-disabled', 'true');
          else btn.removeAttribute('aria-disabled');
          btn.setAttribute(
            'aria-label',
            (sameColour ? 'Seçildi, ' + self.word('ten') + ' çıkarmak için dokun: ' : label + ': ') + shortName(card.dataset.title || '')
          );
        }
        // With units on, the picked colour's "Seçildi" is its stepper, in
        // the button's place (made the first time it is needed).
        var stepper = card.querySelector('[data-xpk-qty-box]');
        var qtyOn = !!self.qtyMax && !giftCard && sameColour && !!btn;
        if (qtyOn && !stepper) {
          stepper = self.stepperEl('xpk__qty--card');
          btn.parentNode.insertBefore(stepper, btn.nextSibling);
        }
        card.classList.toggle('has-qty', qtyOn);
        if (qtyOn) self.fillStepper(stepper, held, true);
      });
    }

    renderSummary() {
      var self = this;
      if (this.summaryImgs) {
        this.summaryImgs.innerHTML = '';
        this.activeSlots().forEach(function (s) {
          if (!s.sel) return;
          var img = document.createElement('img');
          img.src = s.sel.img;
          img.alt = shortName(s.sel.title);
          img.width = 160;
          img.height = 160;
          img.loading = 'lazy';
          self.summaryImgs.appendChild(img);
        });
      }
      if (this.summaryList) {
        this.summaryList.innerHTML = '';
        // A set that takes only some of the rows: those rows say so ("Set
        // içinde"), matching the one set line the cart will show for them.
        var st = this.readyState();
        var partial = !!st.match && (st.rest || []).length > 0;
        var kademeLive = this.kademeLive();
        var at = 0;
        var tag = function (cat) {
          var mine = partial && st.taken.indexOf(at) !== -1;
          at += 1;
          if (!mine) return;
          var chip = document.createElement('span');
          chip.className = 'xpk__sum-tag';
          chip.textContent = 'Set içinde';
          cat.appendChild(chip);
        };
        var teklifShown = false;
        this.activeSlots().forEach(function (s) {
          if (!s.sel) return;
          if (s.ek && self.teklif && !teklifShown) {
            self.summaryList.appendChild(self.teklifRow());
            teklifShown = true;
          }
          var li = document.createElement('li');
          li.className = 'xpk__sum-row';
          var thumb = document.createElement('img');
          thumb.className = 'xpk__sum-thumb';
          thumb.src = s.sel.img;
          thumb.alt = '';
          thumb.width = 40;
          thumb.height = 40;
          var text = document.createElement('div');
          text.className = 'xpk__sum-text';
          var cat = document.createElement('p');
          cat.className = 'xpk__sum-cat';
          cat.textContent = s.ek ? 'Ek ürün · ' + s.label : s.label;
          tag(cat);
          var name = document.createElement('p');
          name.className = 'xpk__sum-name';
          name.textContent = s.sel.title;
          var price = document.createElement('p');
          price.className = 'xpk__sum-price';
          var cut = kademeLive ? self.kademeCut(s) : 0;
          if (cut) {
            var deal = document.createElement('span');
            deal.className = 'xpk__sum-tag';
            deal.textContent = dealText(self.kademeDeal(s), units(s.sel));
            cat.appendChild(deal);
          }
          if (s.gift) {
            li.classList.add('xpk__sum-row--gift');
            var was = document.createElement('s');
            was.textContent = money(s.sel.price);
            var free = document.createElement('span');
            free.className = 'xpk__sum-free';
            free.textContent = 'Ücretsiz';
            price.appendChild(was);
            price.appendChild(document.createTextNode(' '));
            price.appendChild(free);
          } else if (cut) {
            var full = document.createElement('s');
            full.textContent = money(s.sel.price * units(s.sel));
            price.appendChild(full);
            price.appendChild(document.createTextNode(' ' + money(s.sel.price * units(s.sel) - cut)));
          } else {
            price.textContent = money(s.sel.price * units(s.sel));
          }
          text.appendChild(cat);
          text.appendChild(name);
          if (self.qtyMax && !s.gift) {
            var stepper = self.stepperEl('xpk__qty--sum', s.key);
            self.fillStepper(stepper, s, false);
            text.appendChild(stepper);
          }
          var edit = document.createElement('button');
          edit.type = 'button';
          if (s.ek) {
            // An added product: taken out with ×; its head box changes it.
            li.classList.add('xpk__sum-row--ek');
            edit.className = 'xpk__sum-edit xpk__sum-remove';
            edit.dataset.xpkEkRemove = s.key;
            edit.setAttribute('aria-label', shortName(s.sel.title) + ' ' + self.word('ten') + ' çıkar');
            edit.innerHTML =
              '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
          } else {
            edit.className = 'xpk__sum-edit';
            edit.dataset.xpkEdit = s.key;
            edit.setAttribute('aria-label', s.label + ' değiştir');
            edit.innerHTML =
              '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"/><path d="M17.5 3.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4 8.5-8.5Z"/></svg>';
          }
          li.appendChild(thumb);
          li.appendChild(text);
          li.appendChild(price);
          li.appendChild(edit);
          self.summaryList.appendChild(li);
        });
        // The offer taken: its own row at its set price, taken out with ×
        // (built above, placed after the required boxes).
        if (this.teklif && !teklifShown) {
          this.summaryList.appendChild(this.teklifRow());
        }
        // What the set line added: its own row, taken out with ×.
        this.extras.forEach(function (x) {
          var li = document.createElement('li');
          li.className = 'xpk__sum-row xpk__sum-row--extra';
          var thumb = document.createElement('img');
          thumb.className = 'xpk__sum-thumb';
          thumb.src = x.img;
          thumb.alt = '';
          thumb.width = 40;
          thumb.height = 40;
          var text = document.createElement('div');
          text.className = 'xpk__sum-text';
          var cat = document.createElement('p');
          cat.className = 'xpk__sum-cat';
          cat.textContent = 'Ek ürün';
          tag(cat);
          var name = document.createElement('p');
          name.className = 'xpk__sum-name';
          name.textContent = x.title;
          text.appendChild(cat);
          text.appendChild(name);
          var price = document.createElement('p');
          price.className = 'xpk__sum-price';
          price.textContent = money(x.price);
          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'xpk__sum-edit xpk__sum-remove';
          remove.dataset.xpkExtraRemove = x.productId;
          remove.setAttribute('aria-label', (x.short || shortName(x.title)) + ' ' + self.word('ten') + ' çıkar');
          remove.innerHTML =
            '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
          li.appendChild(thumb);
          li.appendChild(text);
          li.appendChild(price);
          li.appendChild(remove);
          self.summaryList.appendChild(li);
        });
      }
    }

    /* "Set kazancın: 197,00 TL" under the footer's total — the whole gain of
       the set in one figure (the builder's price note), no struck price:
       a bundle against today's own prices is not an earlier price. */
    renderGain() {
      if (!this.gainEl) return;
      var st = this.readyState();
      var gain = st.match ? st.compSum - st.match.price : this.kademeSum() + this.teklifCut();
      setText(this.gainEl, gain > 0 ? 'Set kazancın: ' + money(gain) : '');
      this.gainEl.hidden = !(gain > 0);
    }

    /* The summary's two ready-set lines, rebuilt only when what they say
       changes (a rebuilt button would drop the keyboard focus). */
    renderReady() {
      if (!this.readyOn) return;
      var st = this.readyState();
      var on = this.showSummary;
      if (this.matchEl) {
        var matchSig = !on
          ? ''
          : st.match
            ? 'm:' + st.match.handle + ':' + st.compSum + ':' + st.restSum + ':' + this.freeHint
            : st.soldOut && !st.nearest
              ? 's:' + st.soldOut.handle
              : '';
        if (matchSig !== this.matchSig) {
          this.matchSig = matchSig;
          this.matchEl.innerHTML = '';
          this.matchEl.classList.toggle('is-soldout', !st.match && !!matchSig);
          if (matchSig && st.match) this.fillMatch(st);
          else if (matchSig) {
            var t = document.createElement('span');
            t.className = 'xpk__match-text';
            t.textContent = 'Bu seçimin seti şu an stokta değil; ürünler kendi fiyatından eklenir.';
            this.matchEl.appendChild(t);
          }
          this.matchEl.hidden = !matchSig;
        }
      }
      if (this.offerEl) {
        var n = on ? st.nearest : null;
        var offerSig = n ? n.set.handle + ':' + n.pick.variantId + ':' + n.delta + ':' + n.total : '';
        if (offerSig !== this.offerSig) {
          this.offerSig = offerSig;
          this.offerEl.innerHTML = '';
          if (n) this.fillOffer(n);
          this.offerEl.hidden = !n;
        }
      }
    }

    /* The selections ARE a set, said as what the shopper won (owner,
       2026-10-14: "ücretsiz ürün ve şu kadar indirim aldın gibi"), never as
       "hazır set" arithmetic:

         ✓  Kedi Su Pınarı Filtresi X8780 ücretsiz geldi, üstüne 198,00 TL
            set indirimi kazandın
            Sepete tek set olarak eklenir, toplam 25.499,00 TL. */
    fillMatch(st) {
      var set = st.match;
      var gain = st.compSum - set.price;
      var free = gain > 0 ? this.freeItem(gain, st) : null;
      var onTop = free ? gain - free.price : gain;

      var icon = document.createElement('span');
      icon.className = 'xpk__match-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML =
        '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M3.5 8.5l3 3 6-7"/></svg>';
      var text = document.createElement('span');
      text.className = 'xpk__match-text';
      var lead = document.createElement('strong');
      lead.className = 'xpk__match-lead';
      var win = function (str) {
        var em = document.createElement('span');
        em.className = 'xpk__match-win';
        em.textContent = str;
        return em;
      };
      if (free) {
        lead.appendChild(document.createTextNode(free.name + ' '));
        lead.appendChild(win('ücretsiz'));
        lead.appendChild(document.createTextNode(' geldi'));
        if (onTop > 0) {
          lead.appendChild(document.createTextNode(', üstüne '));
          lead.appendChild(win(money(onTop) + ' set indirimi'));
          lead.appendChild(document.createTextNode(' kazandın'));
        }
      } else if (gain > 0) {
        lead.appendChild(document.createTextNode('Set olarak aldığın için '));
        lead.appendChild(win(money(gain) + ' indirim'));
        lead.appendChild(document.createTextNode(' kazandın'));
      } else {
        lead.textContent = 'Bu ürünler birlikte set olarak satılıyor';
      }
      text.appendChild(lead);
      text.appendChild(document.createTextNode(' '));
      var sub = document.createElement('span');
      sub.className = 'xpk__match-sub';
      // Which products become the one set line of the cart, by name — the
      // cart shows the set's own product there, not the products one by one.
      var rest = st.rest || [];
      var setName = '“' + (set.kisaAd || shortName(set.title)) + '”';
      var inSet = this.planLines().inSet.map(itemName);
      sub.textContent = rest.length
        ? listTr(inSet) +
          ' sepete tek satırda ' +
          setName +
          ' olarak, ' +
          (rest.length === 1 ? itemName(rest[0]) : 'diğer ' + rest.length + ' ürün') +
          ' ayrı eklenir; toplam ' +
          money(set.price + st.restSum) +
          '.'
        : 'Hepsi sepete tek satırda ' + setName + ' olarak eklenir; toplam ' + money(set.price) + '.';
      text.appendChild(sub);
      this.matchEl.appendChild(icon);
      this.matchEl.appendChild(text);
    }

    /* The product a set's gain makes free: the one the set line last added
       while it fits inside the gain, else the cheapest that fits. */
    freeItem(gain, st) {
      var sels = this.allSels();
      var fits = (st.taken || [])
        .map(function (i) {
          return sels[i];
        })
        .filter(function (x) {
          return x && (x.price || 0) > 0 && x.price <= gain;
        })
        .sort(function (a, b) {
          return a.price - b.price;
        });
      if (!fits.length) return null;
      var hint = this.freeHint;
      var pick =
        (hint &&
          fits.filter(function (x) {
            return x.productId === hint;
          })[0]) ||
        fits[0];
      return { name: pick.short || shortName(pick.title), price: pick.price };
    }

    /* One part short of a set, said the way a shopper feels it (the set
       builder's nearest line, owner 2026-10-14):

         [img]  Bu ürünü setine ücretsiz ekle             [Ücretsiz ekle]
                Kedi Su Pınarı Filtresi X8783 · normalde 799,00 TL
                Üstüne 298,00 TL set indirimi de kazanırsın

       The part's cost in the set is what the total moves by: ≤ 0 → free (and
       below 0 the total also drops by that much), > 0 → that much under its
       own price. */
    fillOffer(n) {
      var name = n.pick.short || shortName(n.pick.title);
      var own = n.own;
      var free = n.delta <= 0;
      var bonus = free ? -n.delta : own - n.delta;
      if (n.pick.img) {
        var img = document.createElement('img');
        img.className = 'xpk__offer-img';
        img.src = n.pick.img;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 56;
        img.height = 56;
        this.offerEl.appendChild(img);
      }
      var text = document.createElement('div');
      text.className = 'xpk__offer-text';
      var head = document.createElement('p');
      head.className = 'xpk__offer-head';
      head.textContent = free
        ? 'Bu ürünü ' + this.word('ine') + ' ücretsiz ekle'
        : 'Bu ürünü ' + this.word('ine') + ' ' + money(n.delta) + "'ye ekle";
      text.appendChild(head);
      var what = document.createElement('p');
      what.className = 'xpk__offer-what';
      what.textContent = name + ' · normalde ' + money(own);
      text.appendChild(what);
      if (bonus > 0) {
        var extra = document.createElement('p');
        extra.className = 'xpk__offer-extra';
        var amount = document.createElement('strong');
        amount.textContent = money(bonus) + ' set indirimi';
        extra.appendChild(document.createTextNode(free ? 'Üstüne ' : 'Böylece '));
        extra.appendChild(amount);
        extra.appendChild(document.createTextNode(free ? ' de kazanırsın' : ' kazanırsın'));
        text.appendChild(extra);
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'xpk__offer-add btn btn--primary';
      btn.setAttribute('data-xpk-offer-add', '');
      btn.setAttribute(
        'aria-label',
        name +
          (free ? ' ' + this.word('ine') + ' ücretsiz ekle' : ' ' + this.word('ine') + ' ' + money(n.delta) + "'ye ekle") +
          (bonus > 0 ? ', ' + (free ? 'üstüne ' : '') + money(bonus) + ' set indirimi' : '')
      );
      var label = document.createElement('span');
      label.className = 'btn__text';
      label.textContent = free ? 'Ücretsiz ekle' : 'Ekle';
      btn.appendChild(label);
      this.offerEl.appendChild(text);
      this.offerEl.appendChild(btn);
    }

    onOfferAdd() {
      var n = this.readyState().nearest;
      if (!n || this.extras.length >= MAX_EXTRAS) return;
      this.extras.push(n.pick);
      this.freeHint = n.pick.productId;
      this.readyCache = null;
      this.persist();
      this.note((n.pick.short || shortName(n.pick.title)) + ' ' + this.word('ine') + ' eklendi.');
      this.track('xset_nearest_add', { set: n.set.handle, urun: n.pick.handle });
      this.render();
      // The button is gone; the line that says what the set won takes over.
      if (this.matchEl && !this.matchEl.hidden) {
        this.matchEl.setAttribute('tabindex', '-1');
        this.focusEl(this.matchEl);
      } else {
        this.focusEl(this.summaryTitle);
      }
    }

    onExtraRemove(productId) {
      var gone = this.extras.filter(function (x) {
        return x.productId === String(productId);
      })[0];
      if (!gone) return;
      this.extras = this.extras.filter(function (x) {
        return x !== gone;
      });
      if (this.freeHint === gone.productId) this.freeHint = '';
      this.readyCache = null;
      this.persist();
      this.note((gone.short || shortName(gone.title)) + ' ' + this.word('ten') + ' çıkarıldı.');
      this.render();
      this.focusEl(this.summaryTitle);
    }

    note(text) {
      if (!this.noteEl) return;
      // A new note takes the reset's "Geri al" with it.
      this.resetSnap = null;
      this.noteEl.classList.remove('has-undo');
      this.noteEl.textContent = text || '';
      this.noteEl.classList.toggle('is-on', !!text);
      clearTimeout(this.noteTimer);
      if (text) {
        var el = this.noteEl;
        this.noteTimer = setTimeout(function () {
          el.textContent = '';
          el.classList.remove('is-on');
        }, 5000);
      }
    }

    focusEl(el) {
      if (!el) return;
      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        /* an element that cannot take focus keeps the old focus */
      }
    }

    /* ------------------------------------------------------------ scroll */

    /* What covers the top of the screen at the destination: this page's
       head (not in the summary) and the site header — which pins only on the
       way up, so a scroll down does not count it. */
    headOffset(goingUp) {
      var head = this.showSummary || !this.headEl ? 0 : this.headEl.offsetHeight;
      var site = 0;
      if (goingUp || document.body.classList.contains('header-pinned')) {
        site = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      }
      return head + site + 12;
    }

    scrollToEl(el, focusRow) {
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.scrollY;
      var goingUp = top < window.scrollY + 40;
      var y = Math.max(0, top - this.headOffset(goingUp));
      if (Math.abs(y - window.scrollY) < 2) return;
      // The row observer stays quiet until this scroll settles.
      this.scrollLock = true;
      var self = this;
      clearTimeout(this.lockFallback);
      this.lockFallback = setTimeout(function () {
        self.releaseLock();
      }, 1500);
      window.scrollTo({ top: y, behavior: reducedMotion() ? 'auto' : 'smooth' });
    }

    releaseLock() {
      if (!this.scrollLock) return;
      this.scrollLock = false;
      clearTimeout(this.lockFallback);
      this.pickVisibleRow();
    }

    scrollToPool(pool, focusRow) {
      var cat = this.cats.find(function (c) {
        return c.pool === pool;
      });
      if (!cat) return;
      if (this.catsEl && this.catsEl.hidden) this.showSummary = false;
      this.viewPool = pool;
      this.render();
      this.scrollToEl(cat.el);
      if (focusRow) this.focusEl(cat.title);
    }

    /* The step line follows the row under the line 45% down the screen —
       the retailer's own page does the same. */
    observeRows() {
      if (!('IntersectionObserver' in window) || !this.cats.length) return;
      var self = this;
      this.rowsOnLine = {};
      this.rowObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            self.rowsOnLine[e.target.dataset.pool] = e.isIntersecting;
          });
          if (!self.scrollLock) self.pickVisibleRow();
        },
        { rootMargin: '-45% 0px -54% 0px', threshold: 0 }
      );
      this.cats.forEach(function (c) {
        self.rowObserver.observe(c.el);
      });
    }

    pickVisibleRow() {
      if (!this.rowsOnLine || this.showSummary) return;
      var self = this;
      var on = this.cats.find(function (c) {
        return self.rowsOnLine[c.pool];
      });
      if (!on || on.pool === this.viewPool) return;
      // A tapped box stays the target until the shopper scrolls to another row.
      if (this.targetKey) {
        var t = this.slotByKey(this.targetKey);
        if (t && t.pool === on.pool) return;
        this.targetKey = null;
      }
      this.viewPool = on.pool;
      this.render();
    }

    /* Arrows on a row that scrolls. */
    observeTracks() {
      var self = this;
      Array.prototype.forEach.call(this.querySelectorAll('[data-xpk-track]'), function (track) {
        var wrap = track.parentNode;
        var prev = wrap.querySelector('[data-xpk-prev]');
        var next = wrap.querySelector('[data-xpk-next]');
        var update = function () {
          var max = track.scrollWidth - track.clientWidth - 2;
          if (prev) prev.hidden = track.scrollLeft <= 2;
          if (next) next.hidden = track.scrollLeft >= max;
        };
        track.addEventListener(
          'scroll',
          function () {
            update();
            // The shopper swiping a row (not the snap settling at load).
            if (track.scrollLeft > 24) self.hideTip(true);
          },
          { passive: true }
        );
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
        update();
        var step = function (dir) {
          track.scrollBy({ left: dir * Math.max(200, track.clientWidth * 0.8), behavior: reducedMotion() ? 'auto' : 'smooth' });
        };
        if (prev) prev.addEventListener('click', function () { step(-1); });
        if (next) next.addEventListener('click', function () { step(1); });
      });
    }

    /* The fixed footer must not cover the page's last content. */
    measureFoot() {
      if (!this.footEl) return;
      var self = this;
      var set = function () {
        document.documentElement.style.setProperty('--xpk-foot-h', self.footEl.offsetHeight + 'px');
      };
      set();
      if ('ResizeObserver' in window) {
        if (!this.footObserver) this.footObserver = new ResizeObserver(set);
        this.footObserver.observe(this.footEl);
      }
    }

    /* ------------------------------------------------------------ tip */

    showTip() {
      if (!this.tipEl || this.dataset.tooltip !== 'true') return;
      if (window.Shopify && Shopify.designMode) return;
      try {
        if (window.localStorage.getItem(TIP_KEY)) return;
      } catch (e) {
        return;
      }
      if (this.filledCount()) return;
      var card = this.querySelector('[data-xpk-cat]:not([hidden]) [data-xpk-card]');
      if (!card) return;
      var btn = card.querySelector('[data-xpk-pick]');
      var self = this;
      var place = function () {
        if (self.tipEl.hidden) return;
        var host = self.getBoundingClientRect();
        var wide = window.innerWidth >= 750;
        self.tipEl.classList.toggle('is-side', wide);
        if (wide) {
          // Beside the first card's picture, pointing at it.
          var media = card.querySelector('.xpk__card-media') || card;
          var m = media.getBoundingClientRect();
          self.tipEl.style.top = m.top - host.top + m.height / 2 - self.tipEl.offsetHeight / 2 + 'px';
          self.tipEl.style.left = m.right - host.left + 14 + 'px';
        } else {
          // Above the button on a phone.
          var r = btn.getBoundingClientRect();
          self.tipEl.style.top = r.top - host.top - self.tipEl.offsetHeight - 12 + 'px';
          self.tipEl.style.left = Math.max(8, r.left - host.left) + 'px';
        }
      };
      this.tipEl.hidden = false;
      this.tipScrollY = window.scrollY;
      place();
      this.placeTip = place;
      window.addEventListener('resize', place);
    }

    hideTip(remember) {
      if (!this.tipEl || this.tipEl.hidden) return;
      this.tipEl.hidden = true;
      if (this.placeTip) window.removeEventListener('resize', this.placeTip);
      if (remember) {
        try {
          window.localStorage.setItem(TIP_KEY, '1');
        } catch (e) {
          /* shown again next time */
        }
      }
    }

    /* ------------------------------------------------------------ events */

    bind() {
      var self = this;
      this.addEventListener('click', function (event) {
        var el = event.target;
        if (!el || !el.closest) return;
        // "Görüntüle" belongs to set-item-modal.js's document listener.
        if (el.closest('[data-xpk-view]')) return;
        var qty = el.closest('[data-xpk-qty]');
        if (qty) return self.onQtyBtn(qty);
        var pick = el.closest('[data-xpk-pick]');
        if (pick) {
          var card = pick.closest('[data-xpk-card]');
          if (card) self.onPick(card);
          return;
        }
        var sw = el.closest('[data-xpk-swatch]');
        if (sw) return self.onSwatch(sw);
        // The picture and the name select the product too — but never take
        // it out again: only "Seçildi" itself does that.
        var hit = el.closest('[data-xpk-card-hit]');
        if (hit) {
          var hitCard = hit.closest('[data-xpk-card]');
          if (hitCard) {
            var held = self.slotOfGroup(hitCard.dataset.pool, hitCard.dataset.group);
            if (held && held.sel.variantId === hitCard.dataset.variantId) return;
            self.onPick(hitCard);
          }
          return;
        }
        var bin = el.closest('[data-xpk-slot-del]');
        if (bin) {
          var binBox = bin.parentNode && bin.parentNode.querySelector('[data-xpk-slot]');
          var binSlot = self.slots.find(function (s) {
            return s.el === binBox;
          });
          if (binSlot) self.onSlotClear(binSlot);
          return;
        }
        var addOpen = el.closest('[data-xpk-add-open]');
        if (addOpen) return self.onAddOpen(addOpen);
        var addType = el.closest('[data-xpk-add-type]');
        if (addType) {
          if (!addType.disabled) self.onAddType(addType.dataset.xpkAddType);
          return;
        }
        var ekDrop = el.closest('[data-xpk-ek-drop]');
        if (ekDrop) return self.onEkDrop(ekDrop.dataset.xpkEkDrop);
        var ekRemove = el.closest('[data-xpk-ek-remove]');
        if (ekRemove) return self.onEkRemove(ekRemove.dataset.xpkEkRemove);
        var slotEl = el.closest('[data-xpk-slot]');
        if (slotEl) {
          var slot = self.slots.find(function (s) {
            return s.el === slotEl;
          });
          if (slot) self.onSlot(slot);
          return;
        }
        var drop = el.closest('[data-xpk-extra-remove]');
        if (drop) return self.onExtraRemove(drop.dataset.xpkExtraRemove);
        if (el.closest('[data-xpk-offer-add]')) return self.onOfferAdd();
        var edit = el.closest('[data-xpk-edit]');
        if (edit) {
          var s = self.slotByKey(edit.dataset.xpkEdit);
          if (s) self.onSlot(s);
          return;
        }
        if (el.closest('[data-xpk-back]')) return self.onBack();
        if (el.closest('[data-xpk-reset]')) return self.onReset();
        var teklifAdd = el.closest('[data-xpk-teklif-add]');
        if (teklifAdd) return self.onTeklifAdd(teklifAdd.dataset.xpkTeklifAdd);
        var teklifExtra = el.closest('[data-xpk-teklif-extra]');
        if (teklifExtra) return self.onTeklifExtra(teklifExtra.dataset.xpkTeklifExtra);
        var teklifDrop = el.closest('[data-xpk-teklif-drop]');
        if (teklifDrop) return self.onTeklifDrop(teklifDrop.dataset.xpkTeklifDrop);
        if (el.closest('[data-xpk-teklif-remove]')) return self.onTeklifRemove();
        if (el.closest('[data-xpk-undo]')) return self.onUndoReset();
        if (el.closest('[data-xpk-cta]')) return self.onCta();
        if (el.closest('[data-xpk-tip-close]')) return self.hideTip(true);
      });
    }

    /* ------------------------------------------------------------ storage */

    persist() {
      var picks = {};
      // A box's units beyond one, by its key.
      var qty = {};
      this.slots.forEach(function (s) {
        if (!s.sel) return;
        picks[s.key] = s.sel.variantId;
        if (units(s.sel) > 1) qty[s.key] = units(s.sel);
      });
      var extras = this.extras.map(function (x) {
        return x.variantId;
      });
      // The added boxes, in order, so a reload builds them again.
      var ek = this.ekSlots().map(function (s) {
        return { k: s.key, p: s.pool };
      });
      var teklif = this.teklif ? this.teklif.variantId : '';
      if (teklif && units(this.teklif) > 1) qty[TEKLIF_KEY] = units(this.teklif);
      writeStore(
        this.storeKey,
        Object.keys(picks).length || extras.length || ek.length || teklif
          ? { t: Date.now(), picks: picks, qty: qty, extras: extras, ek: ek, teklif: teklif }
          : null
      );
    }

    /* A variant id → the card (and colour) that sells it, in `pool`. */
    findVariant(pool, vid) {
      var cards = this.querySelectorAll('[data-xpk-card]');
      for (var i = 0; i < cards.length; i += 1) {
        var card = cards[i];
        if (card.dataset.pool !== pool) continue;
        if (card.dataset.variantId === String(vid)) return this.cardPick(card);
        if (card.dataset.colors) {
          try {
            var colors = JSON.parse(card.dataset.colors);
            var c = colors.find(function (x) {
              return String(x.vid) === String(vid);
            });
            if (c) {
              return {
                group: card.dataset.group,
                handle: c.h,
                productId: String(c.pid),
                variantId: String(c.vid),
                price: c.p,
                title: c.t || card.dataset.title,
                img: c.img || card.dataset.img,
                stok: parseInt(c.q, 10) || 0,
              };
            }
          } catch (e) {
            /* a broken colour list is just one colour */
          }
        }
      }
      return null;
    }

    /* A product by handle (a card's own, or one of its colours) into its
       row's box: the box already holding that model, else the first empty
       one, else the one filled last. */
    placeHandle(handle, vid) {
      var cards = this.querySelectorAll('[data-xpk-card]');
      var pick = null;
      var pool = null;
      for (var i = 0; i < cards.length && !pick; i += 1) {
        var card = cards[i];
        if (card.dataset.handle === handle) {
          pick = vid ? this.findVariant(card.dataset.pool, vid) : null;
          if (!pick || pick.handle !== handle) pick = this.cardPick(card);
          pool = card.dataset.pool;
          break;
        }
        if (!card.dataset.colors) continue;
        try {
          var colors = JSON.parse(card.dataset.colors);
          var c = colors.find(function (x) {
            return x.h === handle;
          });
          if (c) {
            pick = this.findVariant(card.dataset.pool, c.vid);
            pool = card.dataset.pool;
          }
        } catch (e) {
          /* not this card */
        }
      }
      if (!pick || !pool) return false;
      var boxes = this.activeIn(pool);
      if (!boxes.length) return false;
      var target =
        this.slotOfGroup(pool, pick.group) ||
        boxes.find(function (s) {
          return !s.sel;
        }) ||
        boxes.slice().sort(function (a, b) {
          return b.at - a.at;
        })[0];
      target.sel = pick;
      target.at = ++this.clock;
      return true;
    }

    restore() {
      var picks = null;
      var fromLink = false;
      // ?set=cam.<vid>~hava.<vid>~… (the set builder's share format) wins
      // over what this browser kept, once: it is then saved and dropped from
      // the URL, so later changes are not undone by a reload.
      var tokens = [];
      // ?bas=<handle>[&v=<variant>] (Setiyle Al's "Kendi setini kur" row):
      // that product in its box, on top of what this browser kept.
      var bas = '';
      var basVariant = '';
      try {
        var params = new URLSearchParams(window.location.search);
        var param = params.get('set');
        if (param) {
          param.split('~').forEach(function (tok) {
            var dot = tok.lastIndexOf('.');
            if (dot > 0) tokens.push({ key: tok.slice(0, dot), vid: tok.slice(dot + 1) });
          });
          fromLink = true;
        }
        bas = params.get('bas') || '';
        basVariant = params.get('v') || '';
        if (bas) fromLink = true;
      } catch (e) {
        tokens = [];
      }
      var extraVids = [];
      if (!tokens.length) {
        var rec = readStore(this.storeKey);
        picks = (rec && rec.picks) || null;
        if (picks) {
          Object.keys(picks).forEach(function (key) {
            tokens.push({ key: key, vid: picks[key] });
          });
        }
        if (rec && Array.isArray(rec.extras)) extraVids = rec.extras;
        var teklifVid = (rec && rec.teklif) || '';
        var qtys = (rec && rec.qty) || null;
        if (rec && Array.isArray(rec.ek)) {
          rec.ek.forEach(function (b) {
            if (b && b.p) this.addEk(String(b.p), String(b.k || ''));
          }, this);
        }
      }
      var self = this;
      tokens.forEach(function (tok) {
        var slot = self.slotByKey(tok.key);
        // Not a box: a set part of a link (the builder's "ekstra.<vid>").
        if (!slot) {
          extraVids.push(tok.vid);
          return;
        }
        if (slot.off) return;
        var pick = self.findVariant(slot.pool, tok.vid);
        if (!pick) return;
        // Two boxes of one row never hold one model.
        if (self.slotOfGroup(slot.pool, pick.group)) return;
        // A link naming one step twice: the twin box of the row takes it.
        if (slot.sel) {
          slot = self.activeIn(slot.pool).find(function (s) {
            return !s.sel;
          });
          if (!slot) return;
        }
        slot.sel = pick;
        slot.at = ++self.clock;
      });
      // The units kept with the picks, within today's stock.
      if (this.qtyMax && qtys) {
        Object.keys(qtys).forEach(function (key) {
          var s = self.slotByKey(key);
          if (!s || !s.sel || s.gift) return;
          var n = Math.min(parseInt(qtys[key], 10) || 1, self.qtyCap(s.sel));
          if (n > 1) s.sel = Object.assign({}, s.sel, { qty: n });
        });
      }
      if (bas) this.placeHandle(bas, basVariant);
      // An added box whose product is gone (or never chosen) does not come
      // back empty.
      this.ekSlots()
        .filter(function (s) {
          return !s.sel;
        })
        .forEach(function (s) {
          self.removeEk(s);
        });
      extraVids.forEach(function (vid) {
        if (self.extras.length >= MAX_EXTRAS) return;
        var c = self.partByVariant(vid);
        var x = c && c.available ? self.partPick(c) : null;
        if (!x || self.extras.some(function (e) { return e.productId === x.productId; })) return;
        self.extras.push(x);
      });
      // Kept only while it still makes a set with the boxes.
      this.pruneExtras();
      // The offer, while the set still holds a product it fits.
      if (teklifVid && this.teklifCat) {
        var tPick = this.findVariant(this.teklifCat.pool, teklifVid);
        if (tPick) {
          if (this.qtyMax && qtys && qtys[TEKLIF_KEY]) {
            tPick.qty = Math.max(1, Math.min(parseInt(qtys[TEKLIF_KEY], 10) || 1, this.qtyCap(tPick)));
          }
          this.teklif = tPick;
          this.pruneTeklif();
        }
      }
      this.showSummary = this.complete();
      if (fromLink) {
        this.persist();
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete('set');
          if (bas) {
            url.searchParams.delete('bas');
            url.searchParams.delete('v');
          }
          history.replaceState(history.state, '', url.pathname + url.search + url.hash);
        } catch (e) {
          /* the link stays in the address bar */
        }
      }
    }

    /* ------------------------------------------------------------ cart */

    /* Which packages of this page the cart holds, by their variant ids. */
    applyCart(cart) {
      var sets = {};
      var prefix = this.setPrefix;
      (cart.items || []).forEach(function (item) {
        var id = item.properties && item.properties._set_id;
        if (!id || String(id).indexOf(prefix) !== 0) return;
        if (!sets[id]) sets[id] = [];
        for (var q = 0; q < (item.quantity || 1); q += 1) sets[id].push(String(item.variant_id));
      });
      var sigs = {};
      Object.keys(sets).forEach(function (id) {
        sigs[sets[id].sort().join(',')] = id;
      });
      this.cartSigs = sigs;
    }

    async readCart() {
      try {
        var res = await fetch(((window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart') + '.js', {
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) return;
        this.applyCart(await res.json());
        this.render();
      } catch (e) {
        /* the CTA simply offers the add */
      }
    }

    sectionsToBundle() {
      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );
      return sections;
    }

    makeSetId() {
      return this.setPrefix + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 6);
    }

    async addToCart() {
      if (this.busy) return;
      this.busy = true;
      this.ctaEl.classList.add('is-busy');
      setText(this.ctaLabelEl, 'Ekleniyor…');
      var plan = this.planLines();
      // The set is the one thing the page cannot know is still in stock.
      if (plan.set && !(await this.readyStillAvailable(plan.set))) {
        plan.set.available = false;
        this.readyVersion += 1;
        this.readyCache = null;
        this.busy = false;
        this.ctaEl.classList.remove('is-busy');
        this.note('Bu set az önce tükendi. Ürünler kendi fiyatlarıyla eklenecek; tekrar sepete ekleyebilirsin.');
        this.render();
        return;
      }
      var setId = this.makeSetId();
      var label = this.setLabel;
      var items = plan.lines.map(function (x) {
        return {
          id: Number(x.variantId),
          quantity: units(x),
          properties: { _set_id: setId, _set_adim: x.adim, _set_kaynak: 'paket', Set: label },
        };
      });
      // A ready set: one line of its own product, no visible "Set" — the
      // line IS the set.
      if (plan.set) {
        // Visible in the cart, the checkout and the order: what the set line
        // holds, so a product that went into it is not taken for missing.
        items.unshift({
          id: Number(plan.set.variantId),
          quantity: 1,
          properties: {
            _set_id: setId,
            _set_kaynak: 'paket',
            _set_hazir: plan.set.handle,
            Set: label,
            'İçerik': plan.inSet.map(itemName).join(' + '),
          },
        });
      }
      var added = false;
      var giftUnpriced = false;
      var kademeExpected = this.kademeLive();
      var kademeUnpriced = false;
      var parsed = null;
      try {
        var routes = (window.FoxTheme && FoxTheme.routes) || {};
        var config =
          window.FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig
            ? FoxTheme.utils.fetchConfig('javascript')
            : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } };
        var res = await fetch(
          routes.cart_add_url || '/cart/add',
          Object.assign({}, config, {
            body: JSON.stringify({ items: items, sections: this.sectionsToBundle(), sections_url: window.location.pathname }),
          })
        );
        parsed = await res.json();
        if (!res.ok || parsed.status || parsed.errors) {
          var why = parsed.description || parsed.message || parsed.errors || 'Ürünler sepete eklenemedi.';
          this.note(typeof why === 'string' ? why : 'Ürünler sepete eklenemedi.');
          try {
            if (window.FoxTheme && FoxTheme.pubsub) {
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, { errors: parsed.description, message: parsed.message });
            }
          } catch (e) {
            /* not ours to report */
          }
        } else {
          added = true;
        }
      } catch (e) {
        this.note('Bağlantı sorunu: ürünler sepete eklenemedi. Tekrar dene.');
      }

      if (added) {
        var g = this.giftSlot();
        this.track('xset_add_to_cart', {
          adet: items.reduce(function (n, it) {
            return n + it.quantity;
          }, 0),
          toplam: this.payTotal() / 100,
          hazir: plan.set ? plan.set.handle : '',
          hediye: g && g.sel ? g.sel.handle : '',
        });
        // The drawer and the header count. The add itself is done: a failed
        // read only means the drawer refreshes itself when it opens.
        try {
          var cartRes = await fetch((((window.FoxTheme && FoxTheme.routes) || {}).cart_url || '/cart') + '.js', {
            headers: { Accept: 'application/json' },
          });
          var cart = await cartRes.json();
          // cart.js's subscriber reads cart.sections[id] unguarded.
          cart.sections = (parsed && parsed.sections) || {};
          this.applyCart(cart);
          // The gift must have come out free; a discount switched off or
          // misconfigured would otherwise charge it silently.
          var giftBox = this.giftSlot();
          if (giftBox) {
            var giftLine = (cart.items || []).find(function (item) {
              var pr = item.properties || {};
              return pr._set_id === setId && pr._set_adim === giftBox.key;
            });
            if (giftLine && giftLine.final_line_price > 0) {
              giftUnpriced = true;
              this.track('xset_gift_unpriced', { urun: giftLine.handle });
            }
          }
          // The box set discount must have come off too. Another discount
          // may have won over it (they do not combine): only a cart with no
          // discount at all is worth a word to the shopper.
          if (kademeExpected) {
            var cartItems = cart.items || [];
            var keys = this.baseSlots()
              .concat(this.ekSlots())
              .filter(function (s) {
                return !!this.kademeDeal(s) && !!s.sel;
              }, this)
              .map(function (s) {
                return s.key;
              });
            if (this.teklif) keys.push(TEKLIF_KEY);
            // A line of several units comes back split: the discounted unit
            // and the rest at full price. One discounted line per step will do.
            var cutMissing = keys.some(function (key) {
              var lines = cartItems.filter(function (item) {
                var pr = item.properties || {};
                return pr._set_id === setId && pr._set_adim === key;
              });
              return (
                lines.length > 0 &&
                !lines.some(function (line) {
                  return line.final_line_price < line.original_line_price;
                })
              );
            });
            if (cutMissing) {
              this.track('xset_kademe_unpriced', {});
              kademeUnpriced = !(cart.total_discount > 0);
            }
          }
          try {
            if (window.FoxTheme && FoxTheme.pubsub) {
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
            }
            document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsed } }));
          } catch (e) {
            /* a broken listener is not the shopper's problem */
          }
        } catch (e) {
          this.cartSigs[this.sig()] = setId;
        }
        this.note(
          this.word('in', true) +
            (giftUnpriced
              ? ' sepete eklendi, ancak hediye indirimi uygulanmadı. Lütfen sepetini kontrol et ya da bize yaz.'
              : kademeUnpriced
                ? ' sepete eklendi, ancak set indirimi uygulanmadı. Lütfen sepetini kontrol et ya da bize yaz.'
                : ' sepete eklendi.')
        );
      }
      this.busy = false;
      this.ctaEl.classList.remove('is-busy');
      this.render();
      if (added) this.openCart();
    }

    /* A failed check is no evidence of a sold-out set (the builder's rule). */
    async readyStillAvailable(set) {
      try {
        var root = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.root_url) || '/';
        var r = await fetch(root.replace(/\/$/, '') + '/products/' + set.handle + '.js');
        if (!r.ok) return true;
        var data = await r.json();
        var v = (data.variants || []).find(function (x) {
          return String(x.id) === String(set.variantId);
        });
        return !!(v && v.available);
      } catch (e) {
        return true;
      }
    }

    openCart() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') {
        try {
          drawer.show(this.ctaEl);
          return;
        } catch (e) {
          /* fall through */
        }
      }
      window.location.href = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart';
    }

    track(name, data) {
      if (window.Shopify && Shopify.designMode) return;
      var payload = { aile: this.family, mod: 'paket', adet: this.filledCount(), toplam: this.payTotal() / 100 };
      Object.keys(data || {}).forEach(function (k) {
        payload[k] = data[k];
      });
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(name, payload);
        }
      } catch (e) {
        /* analytics never breaks the page */
      }
      try {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push(Object.assign({ event: name }, payload));
        }
      } catch (e) {
        /* ditto */
      }
    }
  }

  customElements.define('xenon-paket', XenonPaket);
})();
